import momentJalaali from "moment-jalali";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { Calendar2CheckFill, Calendar2DateFill, CalendarDate, Check2, Check2Square, CheckLg, CloudUploadFill, Command, DashCircle, Download, Envelope, ExclamationTriangle, FileEarmarkPlus, FileEarmarkPost, Files, InfoSquareFill, Link45deg, List, Pencil, PencilFill, Person, PersonCheckFill, PersonPlusFill, PlusSquare, Printer, PrinterFill, ReplyFill, Toggles2, Trash, VectorPen } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import NewNumberInput from "../../Components/NewNumberInput";
import ModalInvoiceSerials from "../Components/ModalInvoiceSerials";
import { invoiceTypes, setErrorDialog, getRemainedAccount, keyIsLetterOrNumber, networkManager_CheckIn, networkManager_CheckOut, invoiceStates, chequeStatuses, serviceInvoiceDetailTypes, downloadFile, getAttachmentList, deleteAttachment, attachFile, productCountingUnit, useIsMobileApp } from "../../store/api/CommonFunctions";
import { getInvoiceNewNumber, addEditInvoice, getInvoice, deleteInvoice, sendInvoiceSMS, getDefaultStoragesInfo, getDetailCount, getPrvNextInvoiceID, getServiceInvoiceDetailTypes, testt, approveInvoice, updateInvoiceDate } from "../store/api/Invoice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { setDialog } from "../../store/api/GetAllProduct";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretSquareLeft, faCaretSquareRight, faFileInvoice, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { getSystemSettings } from "../store/api/Invoice";
import ModalConvertToFormalInvoice from "../Components/ModalConvertToFormalInvoice";
import { getDocumentIDByAttachment } from "../../Accounting/store/api/DocumentsAPI";
import BihamtaTable from "../../Components/BihamtaTable";
import ModalCommands from "../../Components/Modals/ModalCommands";
import ModalReminder from "../../Components/Modals/ModalReminder";
import ModalAddEditChequeFunctions from "../../Accounting/Components/ModalAddEditChequeFunctions";
import { getDefinedServicesForSelect } from "../../Services/store/api/TaskDetailsApi";
import ModalSignature from "../../Components/Modals/ModalSignature";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";
import ModalReferDocument from "../../Components/Modals/ModalReferDocument";
import ModalCreateEditWorkItems from "../../Projects/pages/ModalCreateEditWorkItems";

const Invoice = () => {
    const frmNewRow = useRef();
    const divButtons = useRef();
    const inputAttach = useRef();
    const isCopy = useRef(false);
    let buttonsArray = useRef([]);
    const isMobile = useIsMobileApp();
    const frmNewServiceRow = useRef();
    const history = useHistory();
    const checkOut = useRef(true);
    const dispatch = useDispatch();
    const iconClicked = useRef(false);
    const [groupDetails, setGroupDetails] = useState(null);
    const [pendingUpdateDate, setPendingUpdateDate] = useState(false);
    const [showSerial, setSerial] = useState(true);
    const [showAddRow, setAddRow] = useState(false);
    const [selectedServiceStaff, selectServiceStaff] = useState(null);
    const [serviceIsGuarantee, setServiceIsGuarantee] = useState(false);
    const [currentDetailType, setCurrentDetailType] = useState(null);
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [serviceDetailTypes, setServiceDetailTypes] = useState();
    const [definedCosts, setDefinedCosts] = useState();
    const [showAddServiceRow, setAddServiceRow] = useState(false);
    const [checkedIn, setCheckedIn] = useState(true);
    const [showBarcode, setBarcode] = useState(false);
    const [remainedAcc, setRemainedAcc] = useState('');
    const [currentRow, setCurrentRow] = useState(null);
    const [attachList, setAttachList] = useState(null);
    const [currentServiceRow, setCurrentServiceRow] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const [submitError, setSubmitError] = useState(null);
    const [selectedProduct, selectProduct] = useState(null);
    const [invoiceDetails, setInvoiceDetails] = useState([]);
    const [serviceInvoiceDetails, setServiceInvoiceDetails] = useState([]);
    const { invoiceType, invoiceID, isFormal } = useParams();
    const [popStaff, setPopStaff] = useState({ show: false });
    const [showMenuButton, setShowMenuButton] = useState(false);
    const [popSerials, setPopSerials] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popInvoice, setPopInvoice] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popReferDoc, setReferDocPop] = useState({ show: false });
    const [popCommand, setPopCommand] = useState({ show: false });
    const [popReminder, setPopReminder] = useState({ show: false });
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });
    const [modalSignature, setModalSignature] = useState({ show: false });
    const [modalWorkItemData, setModalWorkItemData] = useState({ show: false });
    const { systemSettings, defaultStorages } = useSelector(state => { return { systemSettings: state.InvoiceReducer.systemSettings, defaultStorages: state.InvoiceReducer.defaultStorages } });
    const settingNames = [
        "ProductGrouppingType",
        "ProductDefaultSalePrice",
        "ProductDefaultSalePriceLabel",
        "DefaultSettleSalesInvoice",
        "DefaultSourceStorageHardCode",
        "TaxPercent",
        "DefaultAccTypeInCustomerSelect"
    ];
    const {
        PrePurchase,
        Purchase,
        PreSale,
        Sale,
        Borrow,
        Resid,
        OldParts,
        ReturnFromPurchase,
        ReturnFromSale,
        ReturnFromBorrow,
        Transfer,
        Havaleh,
        ServiceInvoice,
        PreServiceInvoice,
        Disassembly,
        ProductionInvoice
    } = invoiceTypes;
    const productGrouppingType =
        Number(systemSettings?.find?.(s => s.SettingName === "ProductGrouppingType").SettingValue ?? 1);
    const pDefaultSalePrice = systemSettings?.find?.(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue ?? "";
    const pDefaultSalePriceLabel = systemSettings?.find?.(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue ?? "";
    const defaultSettleSalesInvoice = Number(systemSettings?.find?.(s => s.SettingName === "DefaultSettleSalesInvoice")?.SettingValue ?? 0);
    const taxPercent = Number(systemSettings?.find?.(s => s.SettingName === "TaxPercent")?.SettingValue ?? 0);
    const defaultAccTypeInCustomerSelect = systemSettings?.find?.(s => s.SettingName === "DefaultAccTypeInCustomerSelect")?.SettingValue ?? "";
    const [rowData, setRowData] = useState({
        ProductCount: 1,
        UnitPrice: 0,
        TotalPrice: 0,
        Discount: 0,
        DiscountPercent: 0,
        Tax: 0,
        TaxPercent: taxPercent,
        PureTotalPrice: 0
    });
    const [serviceRowData, setServiceRowData] = useState({
        ProductCount: 1,
        UnitPrice: 0,
        TotalPrice: 0,
        Discount: 0,
        Tax: 0,
        TaxPercent: taxPercent,
        PureTotalPrice: 0
    });
    const [invoice, setInvoice] = useState({
        CustomerCat: 0,
        IsFormal: isFormal === "true",
        //PaymentMethod: 0,
        Discount: 0,
        TaxFee: 0,
        InvoiceTotalPrice: 0,
        InvoicePureTotalPrice: 0,
        FreightCharge: 0,
        ContactDate: momentJalaali().local("en").format("YYYY-MM-DD")
    });
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        {
            colTitle: "نام انبار", colName: "StorageName", showInMobile: true,
            showCondition: () => (
                invoiceType === Sale ||
                invoiceType === PreSale ||
                invoiceType === ReturnFromPurchase ||
                invoiceType === Transfer ||
                invoiceType === Havaleh ||
                invoiceType === Borrow ||
                invoiceType === ReturnFromBorrow ||
                invoiceType === OldParts)
        },
        { colTitle: "مشخصات کالا", colName: "ProductCode+ProductName+ProductModel", showInMobile: true, colType: "string" },
        { colTitle: "سریال کالا", colName: "ProductSerial", showInMobile: false, showCondition: () => showSerial, style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "تعداد", colName: "ProductCount", showInMobile: true },
        { colTitle: "قیمت واحد", colName: "UnitPrice", showInMobile: false, colType: "currency", showCondition: () => invoiceType !== Resid && invoiceType !== Havaleh },
        { colTitle: "درصد تخفیف", colName: "DiscountPercent", showInMobile: false, showCondition: () => isFormal === "true" },
        { colTitle: "تخفیف", colName: "Discount", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "درصد مالیات", colName: "TaxPercent", showInMobile: false, showCondition: () => isFormal === "true" },
        { colTitle: "ارزش افزوده", colName: "Tax", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", showInMobile: false, colType: "currency", showCondition: () => invoiceType !== Resid && invoiceType !== Havaleh },
        { colTitle: "واحد شمارش", colName: "PCountingUnit" },
        {
            colTitle: "تعداد در انبار", colName: "ProductCountInStorage",
            showCondition: () => (
                invoiceType === Sale ||
                invoiceType === PreSale ||
                invoiceType === ReturnFromPurchase ||
                invoiceType === Transfer ||
                invoiceType === Havaleh ||
                invoiceType === Borrow ||
                invoiceType === ReturnFromBorrow ||
                invoiceType === OldParts)
        },
        { colTitle: "گارانتی", colName: "IsGuarantee", colType: "boolean", showCondition: () => invoiceType === ServiceInvoice },
        { colTitle: "شرح ردیف", colName: "ItemDescription" },
        {
            colTitle: "سود فروش", colName: "SaleProfit", colType: "currency",
            styleCondition: (row) => Number(row.SaleProfit) < 0 ? { color: "red" } : Number(row.SaleProfit) > 0 ? { color: "#008797" } : {},
            showCondition: () => (invoiceType === Sale || invoiceType === ServiceInvoice) && Number(invoice.InvoiceID) > 0
        },
    ]
    const tableRowButtons = [
        {
            title: "ویرایش ردیف", type: "common", className: "group-Btn-smalll btn-info", showCondition: () => isMobile, onclick: (item) => setCurrentRowForEdit({ ...item }), icon: <PencilFill size={18} color="orange" />
        },
        {
            title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: removeRow
        }
    ]
    const serviceTableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نوع خدمت", colName: "DetailTypeName", showInMobile: true, colType: "string" },
        { colTitle: "شرح خدمت", colName: "ServiceDesc", showInMobile: false },
        { colTitle: "تعداد", colName: "ProductCount", showInMobile: true },
        { colTitle: "قیمت واحد", colName: "UnitPrice", showInMobile: false, colType: "currency" },
        { colTitle: "درصد تخفیف", colName: "DiscountPercent", showInMobile: false, showCondition: () => isFormal === "true" },
        { colTitle: "تخفیف", colName: "Discount", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "درصد مالیات", colName: "TaxPercent", showInMobile: false, showCondition: () => isFormal === "true" },
        { colTitle: "ارزش افزوده", colName: "Tax", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", showInMobile: false, colType: "currency" },
        { colTitle: "گارانتی", colName: "IsGuarantee", colType: "boolean" },
        { colTitle: "تکنسین", colName: "StaffName" },
        { colTitle: "شرح ردیف", colName: "ItemDescription" }
    ]
    const serviceTableRowButtons = [
        {
            title: "ویرایش ردیف", type: "common", className: "group-Btn-smalll btn-info", showCondition: () => isMobile, onclick: (item) => setCurrentServiceRowForEdit({ ...item }), icon: <PencilFill size={18} color="orange" />
        },
        {
            title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: removeServiceRow
        }
    ]
    const groupTableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "مشخصات کالا", colName: "ProductCode+ProductName+ProductModel", showInMobile: true, colType: "string" },
        { colTitle: "تعداد", colName: "ProductCount", showInMobile: true },
        { colTitle: "قیمت واحد", colName: "UnitPrice", showInMobile: false, colType: "currency", showCondition: () => invoiceType !== Resid && invoiceType !== Havaleh },
        { colTitle: "تخفیف", colName: "Discount", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "ارزش افزوده", colName: "Tax", showInMobile: false, colType: "currency", showCondition: () => isFormal === "true" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", showInMobile: false, colType: "currency", showCondition: () => invoiceType !== Resid && invoiceType !== Havaleh },
        { colTitle: "واحد شمارش", colName: "PCountingUnit" },
        { colTitle: "شرح ردیف", colName: "ItemDescription" },
    ]
    const popPrintMenu = (
        <Popover style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle" style={{ paddingRight: "3px" }}><Printer size={18} /> چاپ {pInvoiceType(invoiceType)}</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ paddingRight: "3px" }}>
                <div className="popMenuItem" onClick={printInvoice}><Printer />&nbsp;چاپ {pInvoiceType(invoiceType)}</div>
                <div className="popMenuItem" onClick={printInvoice2}><PrinterFill />&nbsp;چاپ دوم {pInvoiceType(invoiceType)}</div>
            </Popover.Content>
        </Popover>
    )
    const popInfo = (
        <Popover id="popInfo">
            <Popover.Content className="bodyStyle" style={{ fontFamily: "Vazir", fontSize: "11px", color: "blue" }}>
                <label style={{ padding: 0, display: "block" }}>SPACE: انتخاب کالا</label>
                <label style={{ padding: 0, display: "block" }}>TAB: حرکت به فیلد بعدی</label>
                <label style={{ padding: 0, display: "block" }}>ENTER: افزودن به جدول</label>
            </Popover.Content>
        </Popover>
    );
    const popAttachments = (
        (<Popover id="popover-basic" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "InvoiceAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>));

    const popMenu = (
        <Popover id="popMenu" style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle" style={{ paddingRight: "2px" }}><List size={18} /> سایر عملیات</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ padding: "2px" }}>
                {buttonsArray.current.includes("print") &&
                    <OverlayTrigger trigger="click" placement="top" overlay={popPrintMenu}>
                        <div className="popMenuItem" onClick={printInvoice}><Printer />&nbsp;چاپ {pInvoiceType(invoiceType)}</div>
                    </OverlayTrigger>
                }
                {buttonsArray.current.includes("delete") && <div className="popMenuItem" onClick={deleteInvc} ><Trash />&nbsp;حذف {pInvoiceType(invoiceType)}</div>}
                {buttonsArray.current.includes("convert") &&
                    (invoiceType === PreSale || invoiceType === PrePurchase) &&
                    Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                    !invoice.ConvertedToInvoice &&
                    <div className="popMenuItem" onClick={convertToInvoice}><Toggles2 />&nbsp;تبدیل به فاکتور</div>
                }
                {buttonsArray.current.includes("convertF") &&
                    checkedIn &&
                    isFormal !== 'true' &&
                    !invoice.ConvertedToInvoice &&
                    Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                    (invoiceType === PreSale || invoiceType === PrePurchase) &&
                    <div className="popMenuItem" onClick={showModalConvert}><Toggles2 />&nbsp;تبدیل به فاکتور رسمی</div>
                }
                {buttonsArray.current.includes("related") &&
                    invoice.ConvertedToInvoice &&
                    invoice.RelatedInvoiceID &&
                    (invoiceType === PreSale || invoiceType === PrePurchase) &&
                    <div className="popMenuItem" onClick={goToConverted}><FileEarmarkPost /> &nbsp;فاکتور مرتبط</div>
                }
                {buttonsArray.current.includes("link") &&
                    invoiceType === Sale &&
                    Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                    <div className="popMenuItem" onClick={sendSMS}><Envelope />&nbsp;پیامک لینک فاکتور</div>
                }
                {buttonsArray.current.includes("document") &&
                    (invoiceType === Sale ||
                        invoiceType === ServiceInvoice ||
                        invoiceType === Purchase ||
                        invoiceType === ReturnFromPurchase ||
                        invoiceType === ReturnFromSale ||
                        invoiceType === Borrow ||
                        invoiceType === ReturnFromBorrow || invoiceType === OldParts) &&
                    Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                    <div className="popMenuItem" onClick={gotoDocument}><FileEarmarkPost />&nbsp;مشاهده سند فاکتور</div>
                }
                {buttonsArray.current.includes("new") && <div className="popMenuItem" onClick={gotoNewInvoice}><FileEarmarkPlus />&nbsp; فاکتور جدید</div>}
                {buttonsArray.current.includes("copy") && <div className="popMenuItem" onClick={copyInvoice}><Files />&nbsp; تکرار فاکتور</div>}
                {buttonsArray.current.includes("command") && <div className="popMenuItem" onClick={showCommand}><Command /> دستور کار</div>}
                {buttonsArray.current.includes("referDoc") && <div className="popMenuItem" keyname="referDoc" onClick={showDocRefer}><ReplyFill size={17} /><Person className='defaultIcon' />&nbsp;ارجاع به کاربر</div>}
                {buttonsArray.current.includes("reminder") && <div className="popMenuItem" onClick={showModalReminder}><CalendarDate />&nbsp;یادآوری</div>}
                {buttonsArray.current.includes("customerSig") && <div className="popMenuItem" onClick={showSignatureForCustomer}><VectorPen />امضای تحویل گیرنده</div>}
                {buttonsArray.current.includes("salesmanSig") && <div className="popMenuItem" onClick={showSignatureForSalesman}><VectorPen />&nbsp;امضای تحویل دهنده</div>}
                {buttonsArray.current.includes("task") && <div className="popMenuItem" onClick={showModalWorkItemData}><Check2Square />&nbsp;ثبت وظیفه</div>}
                {buttonsArray.current.includes("approve") && (Number(invoice?.InvoiceStateCode) === invoiceStates.Draft || Number(invoice?.InvoiceStateCode) === invoiceStates.WatingForApprove) &&
                    <div className="popMenuItem" onClick={approve}><Check2Square />&nbsp;تایید فاکتور</div>}
                {buttonsArray.current.includes("attachs") &&
                    <OverlayTrigger trigger="click" placement="top" overlay={popAttachments}>
                        <div className="popMenuItem" onClick={loadAttachList}><Link45deg />&nbsp;پیوست ها</div>
                    </OverlayTrigger>
                }
            </Popover.Content>
        </Popover>)

    const popShortKeys = (
        <Popover id="popShortKeys">
            <Popover.Content className="bodyStyle" style={{ fontFamily: "Vazir", fontSize: "11px", color: "blue" }}>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+C:</span> تکرار فاکتور</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+R:</span> یادآوری</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+M:</span> دستور کار</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+N:</span> ردیف جدید</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+P:</span> چاپ فاکتور</label>
                <label style={{ padding: 0, display: "block" }}><span style={{ fontWeight: "bold" }}>ALT+V:</span> فاکتور جدید</label>
                {/* <label style={{ padding: 0, display: "block" }}><span style={{fontWeight:"bold"}}>ALT+L:</span> ثبت فاکتور</label> */}
            </Popover.Content>
        </Popover>
    )


    if (invoice !== "PENDING" && (invoice.PaymentMethod === undefined))
        invoice.PaymentMethod =
            invoiceType === Sale ||
                invoiceType === Purchase ||
                invoiceType === ReturnFromSale ||
                invoiceType === ReturnFromPurchase ||
                invoiceType === ServiceInvoice ? (defaultSettleSalesInvoice ?? 0) : 0;
    const handleKeyPress = useCallback((event) => {
        if (event.altKey && (event.code === "KeyN")) {
            showAddDiv();
        }
        if (event.altKey && (event.code === "KeyZ")) {
            setAddRow(false);
        }
        if (Number(invoiceID) > 0) {
            if (event.altKey && event.code === "KeyC") {
                copyInvoice();
            }
            if (event.altKey && event.code === "KeyR") {
                showModalReminder();
            }
            if (event.altKey && event.code === "KeyP") {
                printInvoice(event);
            }
            if (event.altKey && event.code === "KeyM") {
                showCommand();
            }
            if (event.altKey && event.code === "KeyV") {
                gotoNewInvoice();
            }
        }
        // if(event.altKey && event.code ==="KeyL")
        // {
        //     submitInvoice();
        // }
    }, []);
    const selectText = useCallback((e) => {
        e.target.select();
    }, [])
    function pInvoiceType(invoiceType) {
        switch (invoiceType) {
            case PreSale:
                return "پیش فاکتور فروش";
            case Sale:
                return "فاکتور فروش";
            case PrePurchase:
                return "پیش فاکتور خرید";
            case Purchase:
                return "فاکتور خرید";
            case Resid:
                return "رسید انبار";
            case Borrow:
                return "حواله به نماینده/تکنسین";
            case Havaleh:
                return "حواله انبار";
            case Transfer:
                return "انتقال بین انبارها";
            case ReturnFromBorrow:
                return "برگشت حواله به نماینده";
            case OldParts:
                return "در قبال داغی";
            case ReturnFromSale:
                return "برگشت از فروش";
            case ReturnFromPurchase:
                return "برگشت از خرید";
            case ServiceInvoice:
                return "فروش کالا و خدمات"
            default: return "";
        }
    }
    const showAddDiv = useCallback(() => {
        const f = async () => {
            setServiceRowData({
                ProductCount: 1,
                UnitPrice: 0,
                TotalPrice: 0,
                Discount: 0,
                Tax: 0,
                TaxPercent: taxPercent,
                PureTotalPrice: 0
            });
            setAddServiceRow(false);
            setAddRow(true);
            rowData.TaxPercent = taxPercent;
            rowData.ProductCount = 1;
        }
        f().then(() => {
            const inputProductName = document.getElementById("invoiceDetailProduct");
            inputProductName.focus();
        }
        );
    })
    const showAddServiceDiv = useCallback(() => {
        const f = async () => {
            setRowData({ TaxPercent: taxPercent, ProductCount: 1 });
            selectProduct(null);
            setAddRow(false);
            setAddServiceRow(true);
        }
        f().then(() => {
            //const inputProductName = document.getElementById("invoiceDetailProduct");
            // inputProductName.focus();
        }
        );
    })
    function showModalProduct(e) {
        let searchFieldName = e.currentTarget.name?.replace("Product", "");
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key) || Number(currentRow?.ID) > 0) {
                return;
            }
            e.preventDefault();
        }
        let value = e.target.value;
        if (e.key && e.key !== " ") {
            value += e.key;
        }
        const setData = (data) => {
            if (data) {
                //For Return Invoice
                data.FirstCount = data.SuggestedCount;
                const rowDataCopy = { ...rowData };
                selectProduct(data);
                rowDataCopy.ProductCountInStorage = data.ProductCountInStorage;
                rowDataCopy.ProductCount = data.SuggestedCount;
                rowDataCopy.UnitPrice = data.UnitPrice;
                rowDataCopy.TotalPrice = Number(data.SuggestedCount) * Number(data.UnitPrice);
                if (isFormal === "true") {
                    if (invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale) {
                        //ممکن است بخشی فروش رفته و تعداد مطابقت نکند. بنابراین عدد تخفیف نیز متفاوت خواهد شد
                        //rowData.Discount = Number(data.Discount);
                        rowDataCopy.DiscountPercent = Number(data.DiscountPercent);
                        rowDataCopy.Discount = rowDataCopy.DiscountPercent / 100 * rowDataCopy.TotalPrice;
                        //rowData.Tax = Number(data.Tax);
                        rowDataCopy.TaxPercent = Number(data.TaxPercent);
                        rowDataCopy.Tax = rowDataCopy.TaxPercent / 100 * (rowDataCopy.TotalPrice - rowDataCopy.Discount);
                    }
                    else {
                        rowDataCopy.Discount = Number(rowDataCopy.DiscountPercent ?? 0) / 100 * rowDataCopy.TotalPrice;
                        rowDataCopy.TaxPercent = taxPercent ?? 0
                        rowDataCopy.Tax = (taxPercent ?? 0) / 100 * (rowDataCopy.TotalPrice - rowDataCopy.Discount);
                    }
                }
                else {
                    rowDataCopy.TaxPercent = rowDataCopy.Tax = 0;
                    rowDataCopy.DiscountPercent = rowDataCopy.Discount = 0;
                }
                rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice + rowDataCopy.Tax - rowDataCopy.Discount;
                setRowData(rowDataCopy);
            }
        }
        setPopProduct({
            show: true,
            value: value,// e.key, 
            searchFieldName: searchFieldName,
            isFormal: isFormal,
            customerID: invoice.CustomerID,
            customerCat: invoice.CustomerCat,
            invoiceType: invoiceType,
            setProductData: setData
        });
        if (!showSerial) {
            const inputCount = document.getElementById("invoiceDetailPCount");
            inputCount.focus();
        }
        else {
            const inputProductSerial = document.getElementById("invoiceDetailPSerial");
            inputProductSerial.focus();
        }
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectCustomer = (data) => {
            if (data) {
                setInvoice({ ...invoice, CustomerCat: data.Cat, CustomerID: data.ID, CustomerCode: data.Code, CustomerName: data.Name, DeliverAddress: data.Address ?? "" });

                getRemainedAccount(data.ID, data.Cat, setRemainedAcc);
            }
        }
        let defaultAccType = "";
        if (invoiceType !== Borrow) {
            if (defaultAccTypeInCustomerSelect === "default")
                defaultAccType = invoiceType !== Purchase && invoiceType !== PrePurchase && invoiceType !== ReturnFromPurchase;

            else if (defaultAccTypeInCustomerSelect?.length > 0) {
                defaultAccType = defaultAccTypeInCustomerSelect === "true";
            }
        }
        setPopCustomer({
            show: true,
            value: e.key,
            invoiceCustomers: true,
            justStaff: (invoiceType === Borrow),
            defaultAccType: defaultAccType,
            setCustomerData: onSelectCustomer
        });
    }
    const showCustomer = () => {
        if (Number(invoice.CustomerCat) === 3 && Number(invoice?.CustomerID) > 0)
            window.open("/CRM/AddEditCustomer/" + invoice?.CustomerID);
    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                setInvoice({ ...invoice, DestinationStorageID: data.StorageID, StorageName: data.StorageName });
            }
        }
        setPopStorage({
            show: true,
            isStaffStorage: invoiceType === Resid ||
                invoiceType === Purchase ||
                invoiceType === ReturnFromBorrow ||
                invoiceType === OldParts ||
                invoiceType === ReturnFromSale ||
                invoiceType === Transfer ||
                invoiceType === Havaleh ? false : null,
            setStorageData: onSelectStorage
        })
    }
    function showModalAccLevel3(e) {
        if (e.key) {
            if (e.key === "Tab" || e.key === "Enter" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            if (data) {
                setInvoice({ ...invoice, TargetAccountID: data.AccountID, TargetAccountCat: data.AccountCat, TargetAccountName: data.AccountName });
            }
        }
        setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                setInvoice({ ...invoice, StaffID: data.ID, StaffName: data.LastName });
            }
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    function showModalStaffForService(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            if (data) {
                selectServiceStaff({ StaffID: data.ID, StaffName: data.LastName });
            }
        }
        setPopStaff({ show: true, onSelect: onSelect, excludeAgency: true });
    }
    function addNewRow(data) {
        const rowDataCopy = { ...rowData };
        if (rowData.ProductCount === 0 || (data.ProductSerial?.length > 0 && rowData.ProductCount > 1)) {

            rowDataCopy.ProductCount = 1;
            rowDataCopy.TotalPrice = rowDataCopy.UnitPrice;
            rowDataCopy.Discount = parseFloat(Number(rowDataCopy.DiscountPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
            rowDataCopy.Discount = Number(rowDataCopy.Discount);
            rowDataCopy.Tax = parseFloat(Number(rowDataCopy.TaxPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
            rowDataCopy.Tax = Number(rowDataCopy.Tax);
            rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice + rowDataCopy.Tax - rowDataCopy.Discount;
        }
        const er = {};
        if ((invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale) && invoiceDetails?.length > 0 && Array.isArray(invoiceDetails)) {
            if (Number(data.ParentDetailID) > 0) {
                const dupParentDetailID = invoiceDetails.some(d => Number(d.ParentDetailID) === Number(data.ParentDetailID));

                if (dupParentDetailID) {
                    er.Details = "ردیف فاکتور برگشتی انتخاب شده تکراری است";
                }
            }
            setSubmitError(er);
            if (Object.keys(er).length > 0) {
                return;
            }
        }
        let rowIndex = 1;
        if (invoiceDetails.length > 0) {
            rowIndex = Math.max(...invoiceDetails.map(d => d.Index)) + 1;
        }
        setInvoiceDetails([...invoiceDetails,
        {
            ...rowDataCopy,
            Index: rowIndex,
            ProductCode: selectedProduct.ProductCode,
            ProductID: selectedProduct.ProductID,
            ProductIDForTaxOffice: selectedProduct.IDForTaxOffice,
            ProductName: selectedProduct.ProductName,
            ProductModel: selectedProduct.ProductModel,
            StorageID: selectedProduct.StorageID,
            StorageName: selectedProduct.StorageName,
            GuaranteeID: selectedProduct.GuaranteeID,
            ProductSerial: data.ProductSerial,
            ItemDescription: data.ItemDescription,
            ParentDetailID: data.ParentDetailID,
            CountingUnit: data.CountingUnit,
            PCountingUnit: productCountingUnit.find(p => p.UnitID == data.CountingUnit)?.UnitName,
            DisassemblyDetailID: selectedProduct.DisassemblyDetailID,
            IsGuarantee: data.IsGuarantee?.toString() === "true"
        }]);
        if (data.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) + Number(rowDataCopy.TotalPrice);
            if (isFormal === "true") {
                invoice.Discount = Number(invoice.Discount) + Number(rowDataCopy.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) + Number(rowDataCopy.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) + Number(rowDataCopy.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;
            }
        }
        if (Number(invoice.PaymentMethod) === 1 && !(Number(invoice.InvoiceID) > 0 && Number(invoice.PaidAmount) > 0)) {
            invoice.PaidAmount = invoice.InvoicePureTotalPrice;
        }
        setInvoice({ ...invoice });
        selectProduct(null);
        setRowData({
            ProductCount: 1,
            UnitPrice: 0,
            TotalPrice: 0,
            Discount: 0,
            DiscountPercent: 0,
            Tax: 0,
            TaxPercent: 0,
            PureTotalPrice: 0
        });
        frmNewRow.current.reset();
        const inputProductName = document.getElementById("invoiceDetailProduct");
        inputProductName.focus();

    }
    function editRow(data) {
        if (iconClicked.current) {
            iconClicked.current = false;
            return;
        }
        const er = {};
        const rowDataCopy = { ...rowData };
        if (Number(data.DisassemblyDetailID) > 0) {
            const dupDisassembly = invoiceDetails.some(d => Number(d.DisassemblyDetailID) === Number(data.DisassemblyDetailID) && Number(d.Index) !== Number(data.Index));
            if (dupDisassembly) {
                er.Details = "ردیف فاکتور دمونتاژ تکراری است";
            }
        }
        if ((invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale) && invoiceDetails?.length > 0 && Array.isArray(invoiceDetails)) {
            const dupParentDetailID = invoiceDetails.some(d => Number(d.ParentDetailID) === Number(data.ParentDetailID) && Number(d.Index) !== Number(data.Index));
            if (dupParentDetailID) {
                er.Details = "ردیف فاکتور برگشتی انتخاب شده تکراری است";
            }
        }
        setSubmitError(er);
        if (Object.keys(er).length > 0) {
            return;
        }
        if (rowDataCopy.ProductCount === 0) {
            rowDataCopy.ProductCount = 1;
            rowDataCopy.TotalPrice = rowDataCopy.UnitPrice;
            rowDataCopy.Discount = parseFloat(Number(rowDataCopy.DiscountPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
            rowDataCopy.Discount = Number(rowDataCopy.Discount);
            rowDataCopy.Tax = parseFloat(Number(rowDataCopy.TaxPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
            rowDataCopy.Tax = Number(rowDataCopy.Tax);
            rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice + rowDataCopy.Tax - rowDataCopy.Discount;
        }
        let edittingRow = {};
        if (Number(data.ID) > 0) {
            const oldRow = invoiceDetails.find(d => Number(d.Index) === Number(data.Index) && d.SignedForDelete?.toString() !== "true");
            oldRow.SignedForDelete = true;
            if (data.IsGuarantee?.toString() !== "true") {
                invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(oldRow.TotalPrice);
                if (isFormal?.toString() === "true") {
                    invoice.Discount = Number(invoice.Discount) - Number(oldRow.Discount);
                    invoice.TaxFee = Number(invoice.TaxFee) - Number(oldRow.Tax);
                    invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(oldRow.PureTotalPrice) - Number(invoice.FreightCharge);
                }
            }
        }
        else {
            edittingRow = invoiceDetails.find(d => Number(d.Index) === Number(data.Index) && d.SignedForDelete?.toString() !== "true");
            if (data.IsGuarantee?.toString() !== "true") {
                invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(edittingRow.TotalPrice);
                if (isFormal?.toString() === "true") {
                    invoice.Discount = Number(invoice.Discount) - Number(edittingRow.Discount);
                    invoice.TaxFee = Number(invoice.TaxFee) - Number(edittingRow.Tax);
                    invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(edittingRow.PureTotalPrice) - Number(invoice.FreightCharge);
                }
            }
        }

        Object.assign(edittingRow, {
            ...rowDataCopy,
            ProductCode: selectedProduct.ProductCode,
            ProductID: selectedProduct.ProductID,
            ProductName: selectedProduct.ProductName,
            ProductModel: selectedProduct.ProductModel,
            StorageID: selectedProduct.StorageID,
            StorageName: selectedProduct.StorageName,
            GuaranteeID: selectedProduct.GuaranteeID,
            ProductSerial: data.ProductSerial,
            ItemDescription: data.ItemDescription,
            Index: Number(data.Index),
            CountingUnit: data.CountingUnit,
            PCountingUnit: productCountingUnit.find(p => p.UnitID == data.CountingUnit)?.UnitName,
            ParentDetailID: selectedProduct.ParentDetailID ?? data.ParentDetailID,
            DisassemblyDetailID: selectedProduct.DisassemblyDetailID ?? data.DisassemblyDetailID,
            ProductIDForTaxOffice: data.ProductIDForTaxOffice,
            IsGuarantee: data.IsGuarantee?.toString() === "true",
            SaleProfit: rowData.TotalPrice - rowData.Discount - Number(data.BuyAmount ?? 0) * rowData.ProductCount
        });
        if (Number(data.ID) > 0) { // To Add New Row
            setInvoiceDetails([...invoiceDetails, edittingRow]);
        }
        if (data.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) + Number(edittingRow.TotalPrice);
            if (isFormal?.toString() === "true") {
                invoice.Discount = Number(invoice.Discount) + Number(edittingRow.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) + Number(edittingRow.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) + Number(edittingRow.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;
            }
        }
        if (Number(invoice.PaymentMethod) === 1 && !(Number(invoice.InvoiceID) > 0 && Number(invoice.PaidAmount) > 0)) {
            invoice.PaidAmount = invoice.InvoicePureTotalPrice;
        }
        setInvoice({ ...invoice });
        selectProduct(null);
        setCurrentRow(null);
        setRowData({
            ProductCount: 1,
            UnitPrice: 0,
            TotalPrice: 0,
            Discount: 0,
            DiscountPercent: 0,
            Tax: 0,
            TaxPercent: 0,
            PureTotalPrice: 0
        });
        if (frmNewRow.current) {
            frmNewRow.current.reset();
        }
        const inputProductName = document.getElementById("invoiceDetailProduct");
        if (inputProductName) {
            inputProductName.focus();
        }

    }
    function setCurrentRowForEdit(row) {
        if (groupDetails?.length > 0) {
            return;
        }
        if (iconClicked.current) {
            iconClicked.current = false;
            return;
        }
        if (currentRow) {
            setSubmitError({ IsInEditMode: "ابتدا ردیف پیشین را ثبت کنید" });
            return;
        }
        const { e, target, ...data } = row;
        rowData.ProductCount = Number(data.ProductCount);
        rowData.UnitPrice = Number(data.UnitPrice);
        rowData.TotalPrice = Number(data.TotalPrice);
        rowData.Discount = Number(data.Discount);
        rowData.Tax = Number(data.Tax);
        rowData.PureTotalPrice = Number(data.PureTotalPrice);
        rowData.TaxPercent = Number(data.TaxPercent);
        rowData.DiscountPercent = Number(data.DiscountPercent);
        rowData.ProductCountInStorage = Number(data.ProductCountInStorage);

        selectProduct({
            ProductCode: data.ProductCode,
            ProductID: data.ProductID,
            ProductName: data.ProductName,
            ProductModel: data.ProductModel,
            StorageID: data.StorageID,
            StorageName: data.StorageName,
            ParentDetailID: data.ParentDetailID,
            DisassemblyDetailID: data.DisassemblyDetailID,
            GuaranteeID: data.GuaranteeID
        });
        setCurrentRow(data);
    }
    function removeRow(detail) {
        iconClicked.current = true;
        if (showAddRow || currentRow) {
            return;
        }
        if (detail.ID) {
            invoiceDetails.find(d => d.Index === detail.Index).SignedForDelete = true;
            setInvoiceDetails([...invoiceDetails]);
        }
        else {
            setInvoiceDetails([...invoiceDetails.filter(i => i.Index !== detail.Index)]);
        }
        if (detail.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(detail.TotalPrice);
            if (isFormal === "true") {
                invoice.Discount = Number(invoice.Discount) - Number(detail.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) - Number(detail.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(detail.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;
            }
        }
        setInvoice({ ...invoice });
    }
    function cancelRow() {
        selectProduct(null);
        setRowData({});
        setAddRow(false);
        setCurrentRow(null);
        setSubmitError({ ...submitError, IsInEditMode: null });
    }
    function onRowColChanged(event) {
        event.preventDefault();
        const input = event.target;
        const rowDataCopy = { ...rowData };
        rowDataCopy[input.name] = Number(input.value ?? 0);
        switch (input.name) {

            case "ProductCount":
                if (selectedProduct?.ProductSerial?.length > 0 || currentRow?.ProductSerial?.length > 0) {
                    selectedProduct.SuggestedCount = 1;
                    rowDataCopy.ProductCount = 1;
                    break;
                }
                if (selectedProduct?.FirstCount) {
                    if (invoiceType === ReturnFromBorrow || invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale) {
                        if (rowDataCopy.ProductCount <= Number(selectedProduct.FirstCount)) {
                            selectedProduct.SuggestedCount = rowDataCopy.ProductCount;
                        }
                        else {
                            rowDataCopy.ProductCount = selectedProduct.FirstCount;
                        }
                    }
                    else {
                        selectedProduct.SuggestedCount = rowDataCopy.ProductCount;
                    }
                }
                else if (currentRow) {
                    if (invoiceType === ReturnFromBorrow ||
                        invoiceType === ReturnFromPurchase ||
                        invoiceType === ReturnFromSale) {
                        if (Number(currentRow.ProductCount) !== rowDataCopy.ProductCount) {
                            const onGet = (res) => {
                                if (res.Count) {
                                    if (selectedProduct) {
                                        selectedProduct.FirstCount = res.Count;
                                    }
                                    if (rowDataCopy.ProductCount <= Number(res.Count)) {
                                        currentRow.ProductCount = rowDataCopy.ProductCount;
                                    }
                                    else {
                                        rowDataCopy.ProductCount = currentRow.ProductCount;
                                    }
                                    selectedProduct.SuggestedCount = rowDataCopy.ProductCount;
                                    selectProduct({ ...selectedProduct });
                                }
                            }

                            getDetailCount(currentRow.ParentDetailID, onGet);
                        }
                    }
                    else {
                        currentRow.ProductCount = rowDataCopy.ProductCount;
                        if (selectedProduct) {
                            selectedProduct.SuggestedCount = rowDataCopy.ProductCount;
                        }
                    }
                }
                break;
            case "UnitPrice":
                if (selectedProduct)
                    selectedProduct.UnitPrice = rowDataCopy.UnitPrice;
                break;
            case "Discount":
                if (rowDataCopy.TotalPrice < rowDataCopy.Discount) {
                    rowDataCopy.Discount = rowDataCopy.TotalPrice;
                }
                if (Number(rowDataCopy.TotalPrice ?? 0) === 0) {
                    rowDataCopy.DiscountPercent = 0;
                }
                else {
                    rowDataCopy.DiscountPercent = parseFloat(Number(rowDataCopy.Discount ?? 0) / Number(rowDataCopy.TotalPrice) * 100).toFixed(2);
                    rowDataCopy.DiscountPercent = Number(rowDataCopy.DiscountPercent);
                }
                break;
            case "DiscountPercent":
                if (rowDataCopy.DiscountPercent > 100) {
                    rowDataCopy.DiscountPercent = 100;
                }
                rowDataCopy.Discount = parseFloat(Number(rowDataCopy.DiscountPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
                rowDataCopy.Discount = Number(rowDataCopy.Discount);
                break;
            case "Tax":
                if (Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0) === 0) {
                    rowDataCopy.TaxPercent = 0;
                }
                else if (rowDataCopy.Tax > (Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0))) {
                    rowDataCopy.Tax = Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0);
                }
                else {
                    rowDataCopy.TaxPercent = parseFloat(Number(rowDataCopy.Tax ?? 0) / (Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0)) * 100).toFixed(2);
                    rowDataCopy.TaxPercent = Number(rowDataCopy.TaxPercent);
                }
                break;
            case "TaxPercent":
                if (rowDataCopy.TaxPercent > 100) {
                    rowDataCopy.TaxPercent = 100;
                }
                rowDataCopy.Tax = parseFloat(Number(rowDataCopy.TaxPercent ?? 0) / 100 * (Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0))).toFixed(2);
                rowDataCopy.Tax = Number(rowDataCopy.Tax)
                break;
            default:
                break;

        }
        rowDataCopy.TotalPrice = (rowDataCopy.UnitPrice ?? 0) * (rowDataCopy.ProductCount ?? 0);
        if (input.name !== "Discount" && input.name !== "DiscountPercent") {
            rowDataCopy.Discount = parseFloat(Number(rowDataCopy.DiscountPercent ?? 0) / 100 * Number(rowDataCopy.TotalPrice ?? 0)).toFixed(2);
            rowDataCopy.Discount = Number(rowDataCopy.Discount);
        }
        if (input.name !== "Tax" && input.name !== "TaxPercent" && Number(rowDataCopy.TaxPercent) > 0) {
            const t = (Number(rowDataCopy.TotalPrice ?? 0) - Number(rowDataCopy.Discount ?? 0));
            if (t >= 0) {
                rowDataCopy.Tax = parseFloat(Number(rowDataCopy.TaxPercent ?? 0) / 100 * t).toFixed(2);
                rowDataCopy.Tax = Number(rowDataCopy.Tax);
            }
            else {
                rowDataCopy.Tax = 0;
            }
        }
        if (isFormal === "true") {
            rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice - Number(rowDataCopy.Discount ?? 0) + Number(rowDataCopy.Tax ?? 0);
        }
        else {
            rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice;
        }
        setRowData(rowDataCopy);
    }
    function onServiceRowColChanged(event) {
        event.preventDefault();
        const input = event.target;
        serviceRowData[input.name] = Number(input.value ?? 0);
        switch (input.name) {

            case "Discount":
                if (serviceRowData.TotalPrice < serviceRowData.Discount) {
                    serviceRowData.Discount = serviceRowData.TotalPrice;
                }
                if (Number(serviceRowData.TotalPrice ?? 0) === 0) {
                    serviceRowData.DiscountPercent = 0;
                }
                else {
                    serviceRowData.DiscountPercent = parseFloat(Number(serviceRowData.Discount ?? 0) / Number(serviceRowData.TotalPrice) * 100).toFixed(2);
                    serviceRowData.DiscountPercent = Number(serviceRowData.DiscountPercent);
                }
                break;
            case "DiscountPercent":
                if (serviceRowData.DiscountPercent > 100) {
                    serviceRowData.DiscountPercent = 100;
                }
                serviceRowData.Discount = parseFloat(Number(serviceRowData.DiscountPercent ?? 0) / 100 * Number(serviceRowData.TotalPrice ?? 0)).toFixed(2);
                serviceRowData.Discount = Number(serviceRowData.Discount);
                break;
            case "Tax":
                if (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0) === 0) {
                    serviceRowData.TaxPercent = 0;
                }
                else if (serviceRowData.Tax > (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0))) {
                    serviceRowData.Tax = Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0);
                }
                else {
                    serviceRowData.TaxPercent = parseFloat(Number(serviceRowData.Tax ?? 0) / (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0)) * 100).toFixed(2);
                    serviceRowData.TaxPercent = Number(serviceRowData.TaxPercent);
                }
                break;
            case "TaxPercent":
                if (serviceRowData.TaxPercent > 100) {
                    serviceRowData.TaxPercent = 100;
                }
                serviceRowData.Tax = parseFloat(Number(serviceRowData.TaxPercent ?? 0) / 100 * (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0))).toFixed(2);
                serviceRowData.Tax = Number(serviceRowData.Tax)
                break;
            default:
                break;

        }
        serviceRowData.TotalPrice = (serviceRowData.UnitPrice ?? 0) * (serviceRowData.ProductCount ?? 0);
        if (input.name !== "Discount" && input.name !== "DiscountPercent") {
            serviceRowData.Discount = parseFloat(Number(serviceRowData.DiscountPercent ?? 0) / 100 * Number(serviceRowData.TotalPrice ?? 0)).toFixed(2);
            serviceRowData.Discount = Number(serviceRowData.Discount);
        }
        if (input.name !== "Tax" && input.name !== "TaxPercent" && Number(serviceRowData.TaxPercent) > 0) {
            const t = (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0));
            if (t >= 0) {
                serviceRowData.Tax = parseFloat(Number(serviceRowData.TaxPercent ?? 0) / 100 * t).toFixed(2);
                serviceRowData.Tax = Number(serviceRowData.Tax);
            }
            else {
                serviceRowData.Tax = 0;
            }
        }
        if (isFormal === "true") {
            serviceRowData.PureTotalPrice = serviceRowData.TotalPrice - Number(serviceRowData.Discount ?? 0) + Number(serviceRowData.Tax ?? 0);
        }
        else {
            serviceRowData.PureTotalPrice = serviceRowData.TotalPrice;
        }
        setServiceRowData({ ...serviceRowData });
    }
    function addNewServiceRow(data) {
        if (serviceRowData.ProductCount === 0) {
            serviceRowData.ProductCount = 1;
            serviceRowData.TotalPrice = serviceRowData.UnitPrice;
            serviceRowData.Discount = parseFloat(Number(serviceRowData.DiscountPercent ?? 0) / 100 * Number(serviceRowData.TotalPrice ?? 0)).toFixed(2);
            serviceRowData.Discount = Number(serviceRowData.Discount);
            serviceRowData.Tax = parseFloat(Number(serviceRowData.TaxPercent ?? 0) / 100 * Number(serviceRowData.TotalPrice ?? 0)).toFixed(2);
            serviceRowData.Tax = Number(serviceRowData.Tax);
            serviceRowData.PureTotalPrice = serviceRowData.TotalPrice + serviceRowData.Tax - serviceRowData.Discount;
        }
        const er = {};
        if (currentDetailType === serviceInvoiceDetailTypes.DefinedService) {
            data.ServiceDesc = definedCosts.Data?.find(d => Number(d.ID) === Number(data.DefinedCostID))?.ItemDesc
        }
        else {
            data.ServiceDesc = data.ManualDesc
        }
        setServiceInvoiceDetails([...serviceInvoiceDetails,
        {
            ...serviceRowData,
            IsGuarantee: data.IsGuarantee?.toString() === "true",
            ServiceDesc: data.ServiceDesc,
            ItemDescription: data.ItemDescription,
            DefinedCostID: data.DefinedCostID,
            Index: serviceInvoiceDetails.length + 1,
            DetailTypeName: serviceDetailTypes.Data.find(d => Number(d.ID) === Number(data.DetailType))?.InfoName,
            DetailType: data.DetailType,
            StaffID: data.StaffID,
            StaffName: data.StaffName
        }]);
        if (data.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) + Number(serviceRowData.TotalPrice);
            if (isFormal === "true") {
                invoice.Discount = Number(invoice.Discount) + Number(serviceRowData.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) + Number(serviceRowData.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) + Number(serviceRowData.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;
            }
            if (Number(invoice.PaymentMethod) === 1 && !(Number(invoice.InvoiceID) > 0 && Number(invoice.PaidAmount) > 0)) {
                invoice.PaidAmount = invoice.InvoicePureTotalPrice;
            }
        }
        setInvoice({ ...invoice });
        //selectServiceStaff();
        setServiceRowData({
            ProductCount: 1,
            UnitPrice: 0,
            TotalPrice: 0,
            Discount: 0,
            Tax: 0,
            TaxPercent: taxPercent,
            PureTotalPrice: 0
        });
        frmNewServiceRow.current.reset();
        setServiceIsGuarantee(false);
        // const inputProductName = document.getElementById("serviceInvoiceDetailProduct");
        // inputProductName.focus();

    }
    function editServiceRow(data) {
        // if (iconClicked.current) {
        //     iconClicked.current = false;
        //     return;
        // }
        const er = {};
        setSubmitError(er);
        if (Object.keys(er).length > 0) {
            return;
        }
        if (serviceRowData.ProductCount === 0) {
            serviceRowData.ProductCount = 1;
        }
        let edittingRow = {};
        if (Number(data.ID) > 0) {
            const oldRow = serviceInvoiceDetails.find(d => Number(d.Index) === Number(data.Index) && d.SignedForDelete?.toString() !== "true");
            oldRow.SignedForDelete = true;
            if (data.IsGuarantee?.toString() !== "true") {
                invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(oldRow.TotalPrice);
                if (isFormal?.toString() === "true") {
                    invoice.Discount = Number(invoice.Discount) - Number(oldRow.Discount);
                    invoice.TaxFee = Number(invoice.TaxFee) - Number(oldRow.Tax);
                    invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(oldRow.PureTotalPrice) - Number(invoice.FreightCharge);
                }
            }
        }
        else {
            edittingRow = serviceInvoiceDetails.find(d => Number(d.Index) === Number(data.Index) && d.SignedForDelete?.toString() !== "true");
            if (data.IsGuarantee?.toString() !== "true") {
                invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(edittingRow.TotalPrice);
                if (isFormal?.toString() === "true") {
                    invoice.Discount = Number(invoice.Discount) - Number(edittingRow.Discount);
                    invoice.TaxFee = Number(invoice.TaxFee) - Number(edittingRow.Tax);
                    invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(edittingRow.PureTotalPrice) - Number(invoice.FreightCharge);
                }
            }
        }
        if (currentDetailType === serviceInvoiceDetailTypes.DefinedService) {
            data.ServiceDesc = definedCosts.Data?.find(d => Number(d.ID) === Number(data.DefinedCostID))?.ItemDesc
        }
        else {
            data.ServiceDesc = data.ManualDesc
        }
        Object.assign(edittingRow, {
            ...serviceRowData,
            Index: Number(data.Index),
            IsGuarantee: data.IsGuarantee?.toString() === "true",
            ServiceDesc: data.ServiceDesc,
            ItemDescription: data.ItemDescription,
            DefinedCostID: data.DefinedCostID,
            DetailType: data.DetailType,
            StaffID: data.StaffID,
            StaffName: data.StaffName
        });
        edittingRow.DetailTypeName = serviceDetailTypes.Data?.find(d => Number(d.ID) === Number(data.DetailType))?.InfoName;
        if (Number(data.ID) > 0) { // To Add New Row
            setServiceInvoiceDetails([...serviceInvoiceDetails, edittingRow]);
        }
        if (data.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) + Number(edittingRow.TotalPrice);
            if (isFormal?.toString() === "true") {
                invoice.Discount = Number(invoice.Discount) + Number(edittingRow.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) + Number(edittingRow.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) + Number(edittingRow.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;
            }
            if (Number(invoice.PaymentMethod) === 1 && !(Number(invoice.InvoiceID) > 0 && Number(invoice.PaidAmount) > 0)) {
                invoice.PaidAmount = invoice.InvoicePureTotalPrice;
            }
        }
        setInvoice({ ...invoice });
        setCurrentServiceRow(null);
        setServiceRowData({
            ProductCount: 1,
            UnitPrice: 0,
            TotalPrice: 0,
            Discount: 0,
            Tax: 0,
            TaxPercent: taxPercent,
            PureTotalPrice: 0
        });
        if (frmNewServiceRow.current) {
            frmNewServiceRow.current.reset();
            setServiceIsGuarantee(false);
        }
        // const inputProductName = document.getElementById("serviceInvoiceDetailProduct");
        // if (inputProductName) {
        //     inputProductName.focus();
        // }

    }
    function setCurrentServiceRowForEdit(row) {
        // if (iconClicked.current) {
        //     iconClicked.current = false;
        //     return;
        // }
        if (currentServiceRow) {
            setSubmitError({ IsInEditMode: "ابتدا ردیف پیشین را ثبت کنید" });
            return;
        }
        const { e, target, ...data } = row;
        // serviceRowData.ProductCount = Number(data.ProductCount);
        // serviceRowData.UnitPrice = Number(data.UnitPrice);
        // serviceRowData.TotalPrice = Number(data.TotalPrice);
        // serviceRowData.Discount = Number(data.Discount);
        // serviceRowData.Tax = Number(data.Tax);
        // serviceRowData.PureTotalPrice = Number(data.PureTotalPrice);
        // serviceRowData.TaxPercent = Number(data.TaxPercent);
        // serviceRowData.DiscountPercent = Number(data.DiscountPercent);
        setCurrentServiceRow(prev => ({
            ...prev,
            ProductCount: Number(data.ProductCount),
            UnitPrice: Number(data.UnitPrice),
            TotalPrice: Number(data.TotalPrice),
            Discount: Number(data.Discount),
            Tax: Number(data.Tax),
            PureTotalPrice: Number(data.PureTotalPrice),
            TaxPercent: Number(data.TaxPercent),
            DiscountPercent: Number(data.DiscountPercent)
        }));
        const infoCode = serviceDetailTypes.Data?.find(d => Number(d.ID) === Number(data.DetailType))?.Code
        if (infoCode !== undefined && infoCode !== null) {
            setCurrentDetailType(Number(infoCode));
        }
    }
    function removeServiceRow(detail) {
        iconClicked.current = true;
        if (showAddServiceRow || currentServiceRow) {
            return;
        }
        if (detail.ID) {
            serviceInvoiceDetails.find(d => d.Index === detail.Index).SignedForDelete = true;
            setServiceInvoiceDetails([...serviceInvoiceDetails]);
        }
        else {
            setServiceInvoiceDetails([...serviceInvoiceDetails.filter(i => i.Index !== detail.Index)]);
        }
        if (detail.IsGuarantee?.toString() !== "true") {
            invoice.InvoiceTotalPrice = Number(invoice.InvoiceTotalPrice) - Number(detail.TotalPrice);
            if (isFormal === "true") {
                invoice.Discount = Number(invoice.Discount) - Number(detail.Discount);
                invoice.TaxFee = Number(invoice.TaxFee) - Number(detail.Tax);
                invoice.InvoicePureTotalPrice = Number(invoice.InvoicePureTotalPrice) - Number(detail.PureTotalPrice) + Number(invoice.FreightCharge);
            }
            else {
                if (invoice.DiscountPercent > 0) {
                    invoice.Discount = invoice.InvoiceTotalPrice * invoice.DiscountPercent / 100;
                }
                if (invoice.TaxPercent > 0) {
                    invoice.TaxFee = (invoice.InvoiceTotalPrice - invoice.Discount) * invoice.TaxPercent / 100;
                }
                invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice + invoice.TaxFee - invoice.Discount + invoice.FreightCharge;

            }
        }
        setInvoice({ ...invoice });
    }
    function cancelServiceRow() {
        selectProduct(null);
        setRowData({});
        setAddRow(false);
        setCurrentRow(null);
        setSubmitError({ ...submitError, IsInEditMode: null });
    }
    function cancelServiceRow() {
        setServiceRowData({
            ProductCount: 1,
            UnitPrice: 0,
            TotalPrice: 0,
            Discount: 0,
            Tax: 0,
            TaxPercent: taxPercent,
            PureTotalPrice: 0
        });
        setAddServiceRow(false);
        setCurrentServiceRow(null);
        setSubmitError({ ...submitError, IsInEditMode: null });
    }
    function otherCostChanged(name, el) {
        let value = el.value;
        if (!value || Number(value) < 0) {
            value = 0;
        }
        invoice[name] = Number(value);
        switch (name) {
            case "DiscountPercent":
                if (invoice.DiscountPercent > 100) {
                    invoice.DiscountPercent = 100;
                }
                if (invoice.InvoiceTotalPrice === 0) {
                    invoice.DiscountPercent = 0;
                }
                invoice.Discount = invoice.DiscountPercent / 100 * invoice.InvoiceTotalPrice;
                break;
            case "Discount":
                if (invoice.Discount > invoice.InvoiceTotalPrice) {
                    invoice.Discount = invoice.InvoiceTotalPrice;
                    //el.parentNode.setAttribute("comma-value", invoice.InvoiceTotalPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
                }
                if (invoice.InvoiceTotalPrice === 0) {
                    invoice.Discount = 0;
                    invoice.DiscountPercent = 0;
                    //el.parentNode.setAttribute("comma-value", "0");
                    break;
                }
                invoice.DiscountPercent = Number(parseFloat(invoice.Discount / invoice.InvoiceTotalPrice * 100).toFixed(2));
                break;
            case "TaxPercent":
                if (invoice.TaxPercent > 100) {
                    invoice.TaxPercent = 100;
                }
                if (invoice.InvoiceTotalPrice === 0) {
                    invoice.TaxPercent = 0;
                }
                invoice.TaxFee = invoice.TaxPercent / 100 * (invoice.InvoiceTotalPrice - invoice.Discount);
                break;
            case "TaxFee":
                if (invoice.TaxFee > invoice.InvoiceTotalPrice) {
                    invoice.TaxFee = invoice.InvoiceTotalPrice;
                    //el.parentNode.setAttribute("comma-value", invoice.InvoiceTotalPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
                }
                if (invoice.InvoiceTotalPrice === 0 || invoice.InvoiceTotalPrice === invoice.Discount) {
                    invoice.TaxFee = 0;
                    invoice.TaxPercent = 0;
                    //el.parentNode.setAttribute("comma-value", "0");
                    break;
                }
                invoice.TaxPercent = Number(parseFloat(invoice.TaxFee / (invoice.InvoiceTotalPrice - invoice.Discount) * 100).toFixed(2));
                break;
        }
        invoice.InvoicePureTotalPrice = invoice.InvoiceTotalPrice - invoice.Discount + invoice.TaxFee + invoice.FreightCharge;
        if (Number(invoice.PaymentMethod) === 1 && !(Number(invoice.InvoiceID) > 0 && Number(invoice.PaidAmount) > 0)) {
            invoice.PaidAmount = invoice.InvoicePureTotalPrice;
        }
        setInvoice({ ...invoice });
    }
    function submitInvoice() {
        let error = {};
        if (invoiceType === Purchase ||
            invoiceType === Sale ||
            invoiceType === PrePurchase ||
            invoiceType === PreSale ||
            invoiceType === ReturnFromSale ||
            invoiceType === ServiceInvoice ||
            invoiceType === PreServiceInvoice ||
            invoiceType === ReturnFromPurchase) {
            if (!invoice.CustomerID || Number(invoice.CustomerID) < 1) {
                error.CustomerID = "انتخاب طرف حساب الزامی است";
            }
        }
        if (invoiceType === Purchase ||
            invoiceType === ReturnFromBorrow ||
            invoiceType === Resid ||
            invoiceType === PrePurchase ||
            invoiceType === Transfer ||
            invoiceType === ReturnFromSale /*||
            invoiceType === ServiceInvoice*/) {
            if (!invoice.DestinationStorageID || Number(invoice.DestinationStorageID) < 1) {
                invoice.DestinationStorageID = defaultStorages.DestStorageID;
                if (!(Number(invoice.DestinationStorageID ?? 0) > 0))
                    error.DestinationStorage = "انتخاب انبار مقصد الزامی است";
            }
        }
        if (!invoiceDetails || invoiceDetails.length === 0 || !invoiceDetails.some(i => !i.SignedForDelete)) {
            error.Details = `هیچ ردیفی برای ${pInvoiceType(invoiceType)} ثبت نشده است`;
        }
        else if (invoiceType === Transfer || invoiceType === ReturnFromBorrow) {
            if (invoiceDetails.some(d => Number(d.StorageID) === Number(invoice.DestinationStorageID) && !d.SignedForDelete)) {
                error.Details = "انبار یکی از ردیفهای فاکتور با انبار مقصد برابر است";
            }
        }
        else if (Number(invoice.PaymentMethod) === 1 &&
            invoice.PaidAmount === 0 &&
            (invoiceType === Sale ||
                invoiceType === Purchase ||
                invoiceType === ReturnFromPurchase ||
                invoiceType === ReturnFromSale ||
                invoiceType === ServiceInvoice) &&
            !isMobile) {
            error.Details = "مبلغ تسویه باید عددی بزرگتر از صفر باشد";
        }
        else if (Number(invoice.PaymentMethod) === 1 &&
            (invoice.TargetAccountName ?? "") === "" &&
            (invoiceType === Sale ||
                invoiceType === Purchase ||
                invoiceType === ReturnFromPurchase ||
                invoiceType === ReturnFromSale ||
                invoiceType === ServiceInvoice) && !isMobile) {
            error.Details = `حساب ${invoiceType === Purchase || invoiceType === ReturnFromSale ? "مبدا" : "مقصد"} انتخاب نشده است`;
        }
        if (Number(invoice.PaymentMethod) === 2) {
            invoice.PaidAmount = 0;
        }
        if (showAddDiv) {
            setAddRow(false);
        }
        if (showAddServiceDiv) {
            setAddServiceRow(false);
        }
        setSubmitError(error);
        if (Object.keys(error).length > 0) {
            return;
        }
        invoice.InvoiceType_ = invoiceType;
        invoice.InvoiceDetailList = invoiceDetails;
        if (invoiceType === ServiceInvoice) {
            invoice.ServiceInvoiceDetailList = serviceInvoiceDetails;
        }
        setInvoice("PENDING");
        const onSuccess = (res) => {
            if (Number(res.Invoice?.InvoiceID) > 0) {
                const data = { ...res.Invoice };
                history.replace(`/Sale/Invoice/${invoiceType}/${data.InvoiceID}/${isFormal}`);
                data.InvoiceTotalPrice = res.Invoice.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                if (invoiceType === ServiceInvoice) {
                    data.InvoiceTotalPrice += res.Invoice.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                }
                if (isFormal === "true") {
                    data.InvoicePureTotalPrice = data.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0) + data.FreightCharge;
                    data.InvoicePureTotalPrice += data.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0)
                }
                else {
                    data.InvoicePureTotalPrice = data.InvoiceTotalPrice - data.Discount + data.FreightCharge + data.TaxFee;
                }
                if (data.InvoiceTotalPrice - data.Discount > 0) {
                    data.TaxPercent = Number(parseFloat(data.TaxFee / (data.InvoiceTotalPrice - (data.Discount ?? 0)) * 100).toFixed(2));
                }
                if (data.InvoiceTotalPrice > 0) {
                    data.DiscountPercent = Number(parseFloat(data.Discount / data.InvoiceTotalPrice * 100).toFixed(2));
                }
                if (Number(data.CustomerID) > 0 && Number(data.CustomerCat) > 0)
                    getRemainedAccount(data.CustomerID, data.CustomerCat, setRemainedAcc);


                setInvoice(data);
                setInvoiceDetails(data.InvoiceDetailList);
                setServiceInvoiceDetails(data.ServiceInvoiceDetailList);
                setRowButtonsAlignment();
            }
            else if (res.Invoice) {
                setInvoice(res.Invoice);
            }

        }
        dispatch(addEditInvoice(invoice, onSuccess));
    }
    function deleteInvc() {
        if (invoice.ConvertedToInvoice || !checkedIn) {
            return;
        }
        const onDelete = (res) => {
            if (res === "true" || res === true) {
                history.push("/Sale/SearchInvoice");
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف فاکتور',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteInvoice(invoiceID, invoiceType, onDelete)
        }))
    }
    function convertToInvoice() {
        ///برای هنگامی که تبدیل به خطا می خورد تا نیاز نباشه صفحه رفرش شود
        const tmp = { ...invoice };
        const toConvert = { ...invoice, InvoiceDetailList: invoice.InvoiceDetailList.map(d => ({ ...d })) };
        if (toConvert.InvoiceDetailList.some(d => d.SignedForDelete || !(Number(d.ID) > 0))) {
            setErrorDialog(dispatch, "ابتدا تغییرات را ثبت کنید", "تبدیل پیش فاکتور");
            return;
        }
        toConvert.ContactDate = momentJalaali().local("en").format("YYYY-MM-DD");
        toConvert.ParentInvoiceID = toConvert.InvoiceID;
        toConvert.InvoiceID = 0;
        toConvert.InvoiceType_ = invoiceType.replace("Pre", "");
        toConvert.InvoiceType = 0;
        toConvert.InvoiceDetailList.forEach(d => d.ID = 0);
        setInvoice("PENDING");
        // const onSuccess = (res) => {
        //     if (res.Invoice) {
        //         const data = res.Invoice;
        //         history.push(`/Sale/Invoice/${invoiceType.replace("Pre", "")}/${data.InvoiceID}/${isFormal}`);
        //         res.Invoice.InvoiceTotalPrice = res.Invoice.InvoiceDetailList.map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
        //         if (isFormal === "true") {
        //             data.InvoicePureTotalPrice = data.InvoiceDetailList.map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0);
        //         }
        //         else {
        //             data.InvoicePureTotalPrice = data.InvoiceTotalPrice - data.Discount + data.FreightCharge + data.TaxFee;
        //         }
        //         if (data.InvoiceTotalPrice - data.Discount > 0) {
        //             data.TaxPercent = Number(parseFloat(data.TaxFee / (data.InvoiceTotalPrice - (data.Discount ?? 0)) * 100).toFixed(2));
        //         }
        //         if (data.InvoiceTotalPrice > 0) {
        //             data.DiscountPercent = Number(parseFloat(data.Discount / data.InvoiceTotalPrice * 100).toFixed(2));
        //         }

        //         setInvoice(data);
        //         setInvoiceDetails(data.InvoiceDetailList);
        //     }

        // }
        const onSuccess = (res) => {

            if (Number(res.Invoice?.InvoiceID) > 0) {
                const data = { ...res.Invoice };
                history.push(`/Sale/Invoice/${invoiceType.replace("Pre", "")}/${data.InvoiceID}/${isFormal}`);
                // data.InvoiceTotalPrice = res.Invoice.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                // if (invoiceType === PreServiceInvoice) {
                //     data.InvoiceTotalPrice += res.Invoice.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                // }
                // if (isFormal === "true") {
                //     data.InvoicePureTotalPrice = data.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0) + data.FreightCharge;
                //     data.InvoicePureTotalPrice += data.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0)
                // }
                // else {
                //     data.InvoicePureTotalPrice = data.InvoiceTotalPrice - data.Discount + data.FreightCharge + data.TaxFee;
                // }
                // if (data.InvoiceTotalPrice - data.Discount > 0) {
                //     data.TaxPercent = Number(parseFloat(data.TaxFee / (data.InvoiceTotalPrice - (data.Discount ?? 0)) * 100).toFixed(2));
                // }
                // if (data.InvoiceTotalPrice > 0) {
                //     data.DiscountPercent = Number(parseFloat(data.Discount / data.InvoiceTotalPrice * 100).toFixed(2));
                // }
                // if (Number(data.CustomerID) > 0 && Number(data.CustomerCat) > 0)
                //     getRemainedAccount(data.CustomerID, data.CustomerCat, setRemainedAcc);


                // setInvoice(data);
                // setInvoiceDetails(data.InvoiceDetailList);
                // setServiceInvoiceDetails(data.ServiceInvoiceDetailList);
                // setRowButtonsAlignment();
            }
            else if (res.Invoice) {

                setInvoice(tmp);
                setInvoiceDetails(tmp.InvoiceDetailList);
            }

        }
        dispatch(addEditInvoice(toConvert, onSuccess));

    }
    function printInvoice(e) {
        const reportName = (isFormal === "true" ? "Formal" : "") + invoiceType + "Invoice";
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: reportName, title: "چاپ " + pInvoiceType(invoiceType) });
    }
    function printInvoice2(e) {
        const reportName = (isFormal === "true" ? "Formal" : "") + invoiceType + "Invoice2";
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: reportName, title: "چاپ دوم " + pInvoiceType(invoiceType) });
    }
    function showModalSerials() {
        const setData = (data) => {
            if (data) {
                data.SuggestedCount = 1;
                selectProduct(data);
                const rowDataCopy = { ...rowData };
                rowDataCopy.ProductCount = 1;
                rowDataCopy.UnitPrice = data.UnitPrice;
                rowDataCopy.TotalPrice = Number(data.UnitPrice);
                if (isFormal?.toString().toLowerCase() === "true") {
                    rowDataCopy.Discount = Number(rowDataCopy.DiscountPercent ?? 0) / 100 * rowDataCopy.TotalPrice;
                    rowDataCopy.TaxPercent = taxPercent ?? 0
                    rowDataCopy.Tax = (taxPercent ?? 0) / 100 * (rowDataCopy.TotalPrice - rowDataCopy.Discount);
                }
                else {
                    rowDataCopy.TaxPercent = rowDataCopy.Tax = 0;
                    rowDataCopy.DiscountPercent = rowDataCopy.Discount = 0;
                }
                rowDataCopy.PureTotalPrice = rowDataCopy.TotalPrice + rowDataCopy.Tax - rowDataCopy.Discount;
                setRowData(rowDataCopy);
            }
        }
        setPopSerials({
            show: true,
            filterFaulty: false,
            setData: setData
        })
    }
    function sendSMS() {
        const onDone = (res) => {
            if (res !== "PENDING") {
                if (res.Error) {
                    res = res.Error;
                }
                setErrorDialog(dispatch, res, "پیامک فاکتور");
            }
        }
        sendInvoiceSMS(invoiceID, onDone);
    }
    function showModalConvert() {
        if (!checkedIn) {
            return;
        }
        const details = invoiceDetails.map(d => ({ ...d }));
        if (details.some(d => d.SignedForDelete || !(Number(d.ID) > 0))) {
            setErrorDialog(dispatch, "ابتدا تغییرات را ثبت کنید", "تبدیل پیش فاکتور");
            return;
        }
        setPopInvoice({ show: true, invoiceDetails: details, customerID: invoice.CustomerID, customerCat: invoice.CustomerCat, invoiceType: Sale });
    }
    function gotoDocument() {
        const attachmentType = (invoiceType !== ServiceInvoice ? "Formal" : "") + invoiceType;
        const onGet = (res) => {
            if (res.DocumentID) {
                window.open(`/Accounting/AddEditDocument/${res.DocumentID}`);
            }
        }
        getDocumentIDByAttachment(invoiceID, attachmentType, onGet);
    }
    const onClose = useCallback((event) => {
        event.preventDefault();
        event.returnValue = "";
        if (Number(invoiceID) > 0 && checkOut.current) {

            networkManager_CheckOut({ DocType: invoiceType, DocID: invoiceID });
        }
        return "";
    })
    function setNetCheckIn(res) {
        if (res.Message || res.Error) {
            checkOut.current = false;
            setCheckedIn(false);
        }
        else {
            checkOut.current = true;
            setCheckedIn(true);
        }
    }
    function goToConverted() {
        history.push(`/Sale/Invoice/${invoiceType.replace("Pre", "")}/${invoice.RelatedInvoiceID}/${invoice.RelatedIsFormal}`);
    }
    function onPaymentMethodChanged(e) {
        if (Number(e.target.value)) {
            invoice.PaidAmount = Number(invoice.InvoicePureTotalPrice);
        }
        else if (Number(e.target.value) === 0) {
            invoice.PaidAmount = 0;
        }
        setInvoice({ ...invoice, PaymentMethod: Number(e.target.value) });

    }
    function gotoPrvNextInvoice(next) {
        const onSuccess = (res) => {
            if (Number(res.ID) >= 0) {
                history.push(`/Sale/Invoice/${invoiceType}/${res.ID}/${res.IsFormal ?? isFormal}`);
                setAddRow(false);
                setSubmitError(null);
                setCurrentRow(null);
            }
        }
        getPrvNextInvoiceID(invoiceID, invoiceType, next, onSuccess);
    }
    function gotoNewInvoice() {
        history.push(`/Sale/Invoice/${invoiceType}/0/${isFormal}`);
    }
    function showCommand() {
        setPopCommand({
            show: true,
            //اگر واژه formal نباشد موقع باز کردن فاکتور از دستور کار نمیتوانیم تشخیص دهیم که فاکتور رسمی بوده یا خیر
            attachmentType: (isFormal === "true" ? "Formal" : "") + invoiceType + "Invoice",
            attachmentID: invoiceID
        })
    }
    function showModalReminder() {
        setPopReminder({
            show: true
        })
    }
    function showModalChequeFunction() {
        if (!(Number(invoiceID) > 0)) {
            return;
        }
        const onPay = (res) => {
            invoice.PaymentChequeFunctionID = res;
            submitInvoice();

        }
        const onDelete = () => {
            setInvoice({ ...invoice, PaymentChequeFunctionID: null, PaymentMethod: 0, PaidAmount: 0 });
        }
        setModalCheqFunctions({
            Show: true,
            Mixed: true,
            AccountID: invoice.CustomerID,
            AccountCat: invoice.CustomerCat,
            AccountName: invoice.CustomerName,
            AccountCode: invoice.CustomerCode,
            InvoiceID: invoiceID,
            InvoiceType: invoiceType,
            FunctionID: invoice.PaymentChequeFunctionID ?? 0,
            onInvoicePay: onPay,
            onDeleteInvoiceCheque: onDelete,
            ChequeStatus: invoiceType === Sale || invoiceType === ReturnFromPurchase ? chequeStatuses.in_1_RecieveCheque : chequeStatuses.out_1_PayCheque
        })
    }
    function copyInvoice() {
        isCopy.current = true;
        history.push(`/Sale/Invoice/${invoiceType}/0/${isFormal}`);
    }
    function setRowButtonsAlignment(b) {
        const el = divButtons.current;
        buttonsArray.current = [];
        setShowMenuButton(false);
        if (el) {
            const maxWidth = el.clientWidth - 120;
            const buttons = el.querySelectorAll(".group-Btn");
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].style.display = "unset";
            }
            let sumWidth = 0;
            for (let i = 0; i < buttons.length; i++) {
                const currentBtnWidth = buttons[i].offsetWidth;
                sumWidth += currentBtnWidth;
                const keyName = buttons[i].getAttribute("keyname");
                if (sumWidth >= maxWidth || currentBtnWidth === 0) {
                    buttons[i].style.display = "none";
                    if (keyName) {
                        buttonsArray.current.push(keyName);
                    }
                }
            }
            if (buttonsArray.current?.length > 0) {
                setShowMenuButton(true);
            }
        }
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(invoiceID, "InvoiceAttachment", setAttachList);
        }
    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "InvoiceAttachment", () => getAttachmentList(invoiceID, "InvoiceAttachment", setAttachList)));
    }
    function onDetailTypeChanged(e) {
        const infoID = Number(e.target.value);
        const infoCode = serviceDetailTypes.Data?.find(d => Number(d.ID) === infoID)?.Code
        if (infoCode !== undefined && infoCode !== null) {
            setCurrentDetailType(Number(infoCode));
        }
    }
    function onDefinedServiceChanged(e) {
        const definedID = Number(e.target.value);
        const definedPrice = definedCosts.Data?.find(d => Number(d.ID) === definedID)?.ItemCost;
        if (definedPrice) {
            serviceRowData.UnitPrice = definedPrice;
            serviceRowData.TotalPrice = (serviceRowData.UnitPrice ?? 0) * (serviceRowData.ProductCount ?? 0);
            serviceRowData.Discount = parseFloat(Number(serviceRowData.DiscountPercent ?? 0) / 100 * Number(serviceRowData.TotalPrice ?? 0)).toFixed(2);
            serviceRowData.Discount = Number(serviceRowData.Discount);
            const t = (Number(serviceRowData.TotalPrice ?? 0) - Number(serviceRowData.Discount ?? 0));
            if (t >= 0) {
                serviceRowData.Tax = parseFloat(Number(serviceRowData.TaxPercent ?? 0) / 100 * t).toFixed(2);
                serviceRowData.Tax = Number(serviceRowData.Tax);
            }
            else {
                serviceRowData.Tax = 0;
            }

            if (isFormal === "true") {
                serviceRowData.PureTotalPrice = serviceRowData.TotalPrice - Number(serviceRowData.Discount ?? 0) + Number(serviceRowData.Tax ?? 0);
            }
            else {
                serviceRowData.PureTotalPrice = serviceRowData.TotalPrice;
            }
            setServiceRowData({ ...serviceRowData })
        }
    }
    function showSignatureForCustomer(e) {
        setModalSignature({
            show: true,
            parentID: invoiceID,
            parentType: "Customer" + invoiceType,
            signatureData: invoice.CustomerSignature
        })
    }
    function showSignatureForSalesman(e) {
        setModalSignature({
            show: true,
            parentID: invoiceID,
            parentType: "Salesman" + invoiceType,
            signatureData: invoice.SalesmanSignature
        })
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, invoiceID, "InvoiceAttachment", () => getAttachmentList(invoiceID, "InvoiceAttachment", setAttachList)));
    }
    function approve() {
        const edited = invoiceDetails.some(d => d.SignedForDelete?.toString() === "true");
        if (edited) {
            setErrorDialog(dispatch, "ابتدا ویرایش فاکتور را کامل کنید", "تایید فاکتور");
            return;
        }
        const onApprove = (res) => {
            const oldInvoice = { ...invoice };
            if (res === "PENDING") {
                setInvoice(res);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تایید فاکتور");
                setInvoice(oldInvoice);
                setRowButtonsAlignment();
            }
            else if (res.Data) {
                setErrorDialog(dispatch, res.SuccessMessage, "تایید فاکتور");
                setInvoice(res.Data);
                setRowButtonsAlignment();
                if (Number(res.Data.CustomerID) > 0 && Number(res.Data.CustomerCat) > 0)
                    getRemainedAccount(res.Data.CustomerID, res.Data.CustomerCat, setRemainedAcc);
            }
        }
        approveInvoice(invoiceID, onApprove);
    }
    function handleUpdateDate() {
        if (pendingUpdateDate) {
            return;
        }
        setPendingUpdateDate(true);
        const data = { InvoiceID: invoiceID, InvoiceDate: invoice.ContactDate, InvoiceType: invoiceType }
        const onUpdate = (res) => {
            setPendingUpdateDate(false);
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "بروزرسانی تاریخ فاکتور", 10000);
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "Success", "بروزرسانی تاریخ فاکتور", 10000);
            }
        }
        updateInvoiceDate(data, onUpdate)
    }
    function handleGroupDetails(showGroup) {
        if (!showGroup) {
            setGroupDetails(null);
            return;
        }
        const details = [];
        invoiceDetails.filter(d => !d.SignedForDelete).forEach(dtl => {
            const found = details.find(d => Number(d.ProductID) == Number(dtl.ProductID));
            if (found) {
                found.ProductCount += dtl.ProductCount;
                found.PureTotalPrice += dtl.PureTotalPrice;
                found.Discount += dtl.Discount;
                found.Tax += dtl.Tax;
            }
            else {
                const newDtl = {
                    ProductCount: dtl.ProductCount,
                    ProductID: dtl.ProductID,
                    ProductName: dtl.ProductName,
                    ProductModel: dtl.ProductModel,
                    ProductCode: dtl.ProductCode,
                    Discount: dtl.Discount,
                    Tax: dtl.Tax,
                    PureTotalPrice: dtl.PureTotalPrice,
                    ItemDescription: dtl.ItemDescription,
                    CountingUnit: dtl.CountingUnit
                }
                details.push(newDtl);
            }

        });
        setGroupDetails(details);
    }
    function showDocRefer() {
        setReferDocPop({ show: true, 
            documentHardCode: invoiceType, 
            documentGroupHardCode: "invoice", 
            documentID: invoiceID, documentNumber: invoice?.InvoiceNumber });
    }
    function showModalWorkItemData() {
        setModalWorkItemData({
            show: true,
            title: invoice.Description,
            entityType: invoiceType,
            entityGroupType: (isFormal ? "Formal" : "") + "Invoice",
            entityId: invoice.InvoiceID
        })
    }
    useEffect(() => {
        setGroupDetails(null);
        document.body.classList = "notMain";
        document.title = "بی همتا-فروش و انبار";
        document.addEventListener('keydown', handleKeyPress);
        dispatch(getSystemSettings(settingNames));
        dispatch(getDefaultStoragesInfo());
        if (invoiceType === ServiceInvoice) {
            getDefinedServicesForSelect({ Take: 0 }, setDefinedCosts);
            getServiceInvoiceDetailTypes(setServiceDetailTypes);
        }
        if (submitError) {
            setSubmitError(null);
        }
        if (remainedAcc.RemainedAccount) {
            remainedAcc.RemainedAccount = 0;
        }
        if (!invoiceID || Number(invoiceID) < 1) {
            selectProduct(null);
            setRowData({
                ProductCount: 1,
                UnitPrice: 0,
                TotalPrice: 0,
                Discount: 0,
                DiscountPercent: 0,
                Tax: 0,
                TaxPercent: 0,
                PureTotalPrice: 0
            });
            setServiceRowData({
                ProductCount: 1,
                UnitPrice: 0,
                TotalPrice: 0,
                Discount: 0,
                Tax: 0,
                PureTotalPrice: 0
            });
            if (invoiceDetails.length > 0) {
                setInvoiceDetails([]);
            }
            if (serviceInvoiceDetails.length > 0) {
                setServiceInvoiceDetails([]);
            }
            const onGetInvoiceNumber = (invoiceNumber) => {
                if (invoiceNumber === "PENDING") {
                    setInvoice("PENDING");
                    return;
                }
                if (!isCopy.current) {
                    setInvoice({
                        CustomerCat: 0,
                        IsFormal: isFormal === "true",
                        PaymentMethod:
                            invoiceType === Sale ||
                                invoiceType === Purchase ||
                                invoiceType === ReturnFromSale ||
                                invoiceType === ReturnFromPurchase ||
                                invoiceType === ServiceInvoice ? (defaultSettleSalesInvoice ?? 0) : 0,
                        Discount: 0,
                        TaxFee: 0,
                        InvoiceTotalPrice: 0,
                        InvoicePureTotalPrice: 0,
                        FreightCharge: 0,
                        ContactDate: momentJalaali().local("en").format("YYYY-MM-DD"),
                        InvoiceNumber: invoiceNumber
                    });
                }
                else {
                    isCopy.current = false;
                    const invc = { ...invoice };
                    invc.InvoiceDetailList.forEach(d => { d.ID = 0; d.InvoiceID = 0 });
                    setInvoiceDetails(invc.InvoiceDetailList);
                    if (invoiceType === ServiceInvoice) {
                        invc.ServiceInvoiceDetailList.forEach(d => { d.ID = 0; d.InvoiceID = 0 });
                        setServiceInvoiceDetails(invc.ServiceInvoiceDetailList);
                    }
                    setInvoice({
                        CustomerCat: invc.CustomerCat,
                        CustomerID: invc.CustomerID,
                        CustomerName: invc.CustomerName,
                        IsFormal: isFormal === "true",
                        PaymentMethod: invoiceType === Sale ||
                            invoiceType === Purchase ||
                            invoiceType === ReturnFromSale ||
                            invoiceType === ReturnFromPurchase ||
                            invoiceType === ServiceInvoice ? (defaultSettleSalesInvoice ?? 0) : 0,
                        InvoiceTotalPrice: invc.InvoiceTotalPrice,
                        InvoicePureTotalPrice: invc.InvoicePureTotalPrice,
                        TaxPercent: invc.TaxPercent,
                        DiscountPercent: invc.DiscountPercent,
                        Discount: invc.Discount,
                        TaxFee: invc.TaxFee,
                        FreightCharge: invc.FreightCharge,
                        ContactDate: momentJalaali().local("en").format("YYYY-MM-DD"),
                        InvoiceNumber: invoiceNumber
                    });
                }
            }
            getInvoiceNewNumber(invoiceType, isFormal, onGetInvoiceNumber);
        }
        else if (Number(invoiceID) > 0) {
            const onGetInvoice = (data) => {
                if (data.Error) {
                    setErrorDialog(dispatch, data.Error, "دریافت اطلاعات فاکتور");
                }
                else {
                    if (data !== "PENDING") {

                        data.InvoiceTotalPrice = data.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                        if (invoiceType === ServiceInvoice) {
                            data.InvoiceTotalPrice += data.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.TotalPrice).reduce((a, b) => a + b, 0);
                        }
                        if (isFormal === "true") {
                            data.InvoicePureTotalPrice = data.InvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0) + data.FreightCharge;
                            if (invoiceType === ServiceInvoice) {
                                data.InvoicePureTotalPrice += data.ServiceInvoiceDetailList.filter(d => d.IsGuarantee?.toString() !== "true").map(d => d.PureTotalPrice).reduce((a, b) => a + b, 0)
                            }
                        }
                        else {
                            data.InvoicePureTotalPrice = data.InvoiceTotalPrice - data.Discount + data.FreightCharge + data.TaxFee;
                        }
                        if (data.InvoiceTotalPrice - data.Discount > 0) {
                            data.TaxPercent = Number(parseFloat(data.TaxFee / (data.InvoiceTotalPrice - (data.Discount ?? 0)) * 100).toFixed(2));
                        }
                        if (data.InvoiceTotalPrice > 0) {
                            data.DiscountPercent = Number(parseFloat(data.Discount / data.InvoiceTotalPrice * 100).toFixed(2));
                        }
                        window.addEventListener('beforeunload', onClose);
                        dispatch(networkManager_CheckIn({ DocType: invoiceType, DocID: invoiceID }, setNetCheckIn));

                        if (data.CustomerRemainedAccount) {
                            const type = Number(data.CustomerRemainedAccount) > 0 ? "بستانکار" : "بدهکار";
                            const color = Number(data.CustomerRemainedAccount) > 0 ? "green" : "red";
                            setRemainedAcc({ RemainedAccount: Math.abs(Number(data.CustomerRemainedAccount)), Type: type, Color: color });
                        }
                    }
                    async function loadInfo() {
                        setInvoice(data);
                        setInvoiceDetails(data.InvoiceDetailList);
                        if (invoiceType === ServiceInvoice) {
                            setServiceInvoiceDetails(data.ServiceInvoiceDetailList);
                        }
                    }
                    loadInfo().then(() => {
                        setRowButtonsAlignment();
                        window.addEventListener("resize", setRowButtonsAlignment);
                    });
                }
            }
            getInvoice(invoiceID, invoiceType, onGetInvoice);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('beforeunload', onClose);
            window.removeEventListener("resize", setRowButtonsAlignment);
            if (Number(invoiceID) > 0 && checkOut.current) {
                networkManager_CheckOut({ DocType: invoiceType, DocID: invoiceID });
            }
        };
    }, [handleKeyPress, invoiceID, invoiceType, isFormal]);
    return (
        <div className="container-fluid mt-1" id="InvoiceContainer">
            <br />
            {Array.isArray(invoiceDetails) && popInvoice.show && <ModalConvertToFormalInvoice popData={popInvoice} setPopData={setPopInvoice} parentInvoiceID={invoice.InvoiceID} />}
            <ModalInvoiceSerials popData={popSerials} setPopData={setPopSerials} productGrouppingType={productGrouppingType} />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType}
                defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} defaultStorages={defaultStorages} />
            <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
            <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <ModalReferDocument popData={popReferDoc} setPopData={setReferDocPop} />
            <ModalCreateEditWorkItems modalData={modalWorkItemData} setModalData={setModalWorkItemData} />
            <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData}
                dataUrl={`api/InvoiceAPI/GetInvoice?invoiceID=${invoiceID}&invoiceType=${invoiceType}`}
                method="get" />
            {Number(invoiceID) > 0 &&
                <Fragment>
                    <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
                    <ModalSignature popData={modalSignature} setPopData={setModalSignature} />
                </Fragment>
            }
            <ModalReminder pop={popReminder} setPop={setPopReminder} attachmentID={invoiceID} attachmentType={(isFormal === "true" ? "Formal" : "") + invoiceType + "Invoice"} />
            <Card >
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faFileInvoice} size="lg" /> {pInvoiceType(invoiceType) + (isFormal === "true" && invoiceType !== ServiceInvoice ? " رسمی" : "")}
                    &nbsp;
                    {invoice.PInvoiceState &&
                        <span style={{ border: "2px solid blue", padding: "7px", borderRadius: "3px", fontSize: "12px", marginRight: "10px", position: "absolute", top: 0, boxShadow: "0px 0px 3px blue" }} className="rotate">
                            {invoice.PInvoiceState}
                        </span>
                    }
                    {!isMobile && Number(invoiceID) > 0 &&
                        <Col md={1} style={{ position: "absolute", left: "50%", right: "50%", top: "5px" }}>
                            <label className="tooltipBtn" data-tooltip="فاکتور بعدی">
                                <FontAwesomeIcon icon={faCaretSquareRight} color="#c0c0e0" size="2x" style={{ marginLeft: "5px" }} onClick={() => gotoPrvNextInvoice(true)} />
                            </label>
                            <label className="tooltipBtn" data-tooltip="فاکتور قبلی">
                                <FontAwesomeIcon icon={faCaretSquareLeft} color="#c0c0e0" size="2x" onClick={() => gotoPrvNextInvoice(false)} />
                            </label>
                        </Col>
                    }
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }} >
                    {invoice === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader type="BallTriangle" color="#bb1370" width="30" height="30" />
                        </div>
                    }
                    {invoice && invoice !== "PENDING" &&
                        <Fragment>
                            <div className="row" style={{ border: "1px solid gray", borderRadius: "3px", padding: "0px 8px 15px 8px", margin: "0" }}>
                                <div className="col-md-4 form-group" style={{ marginLeft: "auto" }}>
                                    {(invoiceType === Purchase ||
                                        invoiceType === Sale ||
                                        invoiceType === PrePurchase ||
                                        invoiceType === PreSale ||
                                        invoiceType === Borrow ||
                                        invoiceType === ReturnFromPurchase ||
                                        invoiceType === ReturnFromSale ||
                                        invoiceType === ServiceInvoice ||
                                        invoiceType === PreServiceInvoice)
                                        &&
                                        <div className="row">
                                            <label onClick={showCustomer} style={{ cursor: (Number(invoice.CustomerCat) === 3 && Number(invoice?.CustomerID) > 0) ? "pointer" : "default" }}>{invoiceType === Borrow ? "نماینده/تکنسین" : "طرف حساب"}</label>
                                            <div className="col-md-7" style={{ maxHeight: "max-content" }}>
                                                <input type="text" className="form-control" onKeyDown={showModalCustomer} readOnly value={(invoice.CustomerCode ? invoice.CustomerCode + "-" : "") + (invoice.CustomerName ?? "")}></input>
                                                <Button className="btn-input-tiny" style={{ top: "8px", left: "5px" }} onClick={showModalCustomer}><List size={21} /></Button>
                                            </div>
                                            <div className="col-md-4 mt-1" style={{ display: "flex", paddingRight: isMobile ? "12px" : "0px" }}>
                                                {Number(remainedAcc.RemainedAccount) > 0 && <span style={{ color: remainedAcc.Color, marginTop: "auto", marginBottom: "auto", border: "2px solid #3b629b", borderRadius: "3px", padding: "4px" }}>{Math.abs(Number(remainedAcc.RemainedAccount)).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) + remainedAcc.Type}</span>}
                                                {remainedAcc === "PENDING" && <span style={{ position: "absolute", top: "35px", left: "-120px" }}><Loader type="BallTriangle" width={15} height={15} color="#bb1370" /></span>}
                                            </div>
                                            {submitError && submitError.CustomerID && <small className="errors">{submitError.CustomerID}</small>}
                                        </div>}
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>تاریخ {pInvoiceType(invoiceType)}</label>
                                    <DatePicker isGregorian={false} timePicker={false} className="form-control" onChange={value => { setInvoice({ ...invoice, ContactDate: value.local("en").format("YYYY-MM-DD") }) }}
                                        value={momentJalaali(invoice.ContactDate.substring(0, 10))} />
                                    {Number(invoiceID) > 0 &&
                                        <Button className="btn-input-tiny tooltipBtn" data-tooltip="بروزرسانی تاریخ فاکتور"
                                            onClick={handleUpdateDate}
                                            style={{ position: "absolute" }} disabled={pendingUpdateDate}>
                                            <Check2Square size={20} />
                                        </Button>
                                    }
                                </div>
                                <div className="col-md-2 form-group">
                                    <label className="ellipsisLabel" title={'شماره سیستمی ' + pInvoiceType(invoiceType)}>شماره سیستمی {pInvoiceType(invoiceType)}</label>
                                    <input type="text" className="form-control" value={invoice.InvoiceNumber ?? ""} readOnly />
                                </div>
                                {!isMobile &&
                                    <div className="col-md-2 form-group">
                                        <label className="ellipsisLabel" title={'شماره دستی ' + pInvoiceType(invoiceType)}>شماره دستی {pInvoiceType(invoiceType)}</label>
                                        <input type="text" className="form-control" value={invoice.ManualInvoiceNumber ?? ""} onChange={e => setInvoice({ ...invoice, ManualInvoiceNumber: e.target.value })} />
                                    </div>
                                }
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-1" style={{ marginLeft: "auto" }}>
                                    {!showAddRow && <Button className="group-Btn-smalll mt-1" title="ردیف جدید" onClick={showAddDiv}><PlusSquare size={18} /></Button>}
                                </div>
                                <div className="col-md-4" style={{ textAlign: "left" }}>
                                    <input type="checkbox" className="form-check-input" onChange={e => setBarcode(e.target.checked)} style={{ marginTop: "17px" }} />
                                    &nbsp;
                                    <label style={{ color: "blue", marginTop: "16px" }}>نمایش بارکد</label>
                                    &nbsp;&nbsp;
                                    <input type="checkbox" className="form-check-input" defaultChecked={showSerial} onChange={e => setSerial(e.target.checked)} style={{ marginTop: "17px" }} />
                                    &nbsp;
                                    <label style={{ color: "blue", marginTop: "16px" }}>نمایش سریال</label>
                                    &nbsp;&nbsp;
                                    <input type="checkbox" className="form-check-input" onChange={e => handleGroupDetails(e.target.checked)} style={{ marginTop: "17px" }} />
                                    &nbsp;
                                    <label style={{ color: "blue", marginTop: "16px" }}>نمایش به تفکیک کالا</label>
                                </div>
                            </div>
                            {(showAddRow || currentRow) &&
                                <form onSubmit={handleSubmit(currentRow ? editRow : addNewRow)} readOnly ref={frmNewRow}>
                                    <div className="scThin" style={{ overflowX: "auto" }}>
                                        <div className="form-group" style={{ border: "1px solid gray", padding: "8px", borderRadius: "3px", backgroundColor: "#cdd7e273", minWidth: !isMobile ? "1190px" : 0, position: "relative" }} >
                                            {!isMobile &&
                                                <table className="flexTable">
                                                    <thead>
                                                        <tr>
                                                            {showBarcode && <th>بارکد کالا</th>}
                                                            <th>مشخصات کالا</th>
                                                            {showSerial && <th>سریال کالا</th>}
                                                            <th style={{ width: "50px" }}><label style={{ width: "50px" }}>تعداد</label></th>
                                                            {invoiceType !== Resid && invoiceType !== Havaleh && <th>قیمت واحد</th>}
                                                            {isFormal === "true" &&
                                                                <Fragment>
                                                                    <th>تخفیف</th>
                                                                    <th>مالیات</th>
                                                                </Fragment>
                                                            }
                                                            {invoiceType !== Resid && invoiceType !== Havaleh && <th>قابل پرداخت</th>}
                                                            {invoiceType === ServiceInvoice &&
                                                                <th style={{ width: "95px" }} ><label style={{ width: "95px" }}>وضعیت گارانتی</label></th>
                                                            }
                                                            <th>واحد شمارش</th>
                                                            <th>توضیحات</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            {showBarcode && <td><input type="text" className="tableRowInput" name="BarCode" onKeyDown={showModalProduct} readOnly value={selectedProduct?.BarCode ?? ""} /></td>}
                                                            <td>
                                                                <input type="hidden" value={currentRow?.ProductCountInStorage ?? 0} readOnly name="ProductCountInStorage" ref={register({})} />
                                                                <input type="hidden" value={currentRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                                <input type="hidden" value={currentRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                                <input type="hidden" value={currentRow?.ProductIDForTaxOffice ?? ""} readOnly name="ProductIDForTaxOffice" ref={register({})} />
                                                                <input type="hidden" name="ParentDetailID" readOnly value={selectedProduct?.ParentDetailID ?? currentRow?.ParentDetailID ?? ""} ref={register({})} />
                                                                <input type="hidden" name="DisassemblyDetailID" readOnly value={selectedProduct?.DisassemblyDetailID ?? currentRow?.DisassemblyDetailID ?? ""} ref={register({})} />
                                                                <input type="hidden" name="BuyAmount" readonly value={currentRow?.BuyAmount ?? 0} ref={register({})} />
                                                                <input id="invoiceDetailProduct" ref={register({ required: true })} type="text" className="tableRowInput" onKeyDown={showModalProduct} readOnly style={{ borderColor: "#534082" }}
                                                                    value={selectedProduct?.ProductName ? (selectedProduct.ProductCode + "-" + selectedProduct.ProductName + "-" + selectedProduct.ProductModel) : currentRow?.ProductName ? currentRow.ProductCode + "-" + currentRow?.ProductName + "-" + currentRow?.ProductModel : ""} name="ProductName" />
                                                                {errors && errors.ProductName && <small className="errors">انتخاب کالا الزامی است</small>}
                                                            </td>
                                                            {showSerial &&
                                                                <td>
                                                                    <div>
                                                                        <input id="invoiceDetailPSerial" type="text" className="tableRowInput" name="ProductSerial" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px", borderColor: "#534082" }}
                                                                            value={selectedProduct?.ProductSerial ?? currentRow?.ProductSerial ?? ""} readOnly={Number(selectedProduct?.GuaranteeID) > 0 || Number(currentRow?.GuaranteeID) > 0} onChange={e => selectProduct({ ...selectedProduct, ProductSerial: e.target.value })} />
                                                                        {(invoiceType === Sale || invoiceType === Havaleh || invoiceType === Transfer) && !(Number(currentRow?.ID) > 0) && <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalSerials}><List size={16} /></Button>}
                                                                    </div>
                                                                </td>}
                                                            <td style={{ width: "50px" }}>
                                                                <input id="invoiceDetailPCount" type="number" className="tableRowInput" name="ProductCount"
                                                                    onChange={onRowColChanged} style={{ width: "48px", borderColor: "#534082" }}
                                                                    value={selectedProduct?.SuggestedCount ?? currentRow?.ProductCount ?? 1} min={0} step={0.01} onFocus={selectText} />
                                                                {errors && errors.ProductCount && <small className="error">تعداد کالا الزامی است</small>}
                                                            </td>
                                                            {invoiceType !== Resid && invoiceType !== Havaleh &&
                                                                <td>
                                                                    <NewNumberInput className="tableRowInput mt-0" minvalue={0} inputname="UnitPrice" value={selectedProduct?.UnitPrice ?? rowData.UnitPrice ?? 0}
                                                                        onChange={onRowColChanged} step={0.01} readonly={invoiceType === Transfer || invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale} />
                                                                </td>
                                                            }
                                                            {isFormal === "true" &&
                                                                <Fragment>
                                                                    <td>
                                                                        <div style={{ position: "relative", display: "inline-block", width: showSerial || showBarcode ? "40%" : "30%" }}>
                                                                            <input type="number" className="tableRowInput" /*readOnly={invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale}*/
                                                                                max={100} min={0} name="DiscountPercent" value={rowData.DiscountPercent ?? 0} onChange={onRowColChanged} step={0.01} onFocus={selectText} style={{ borderRadius: "0px 4px 4px 0px", borderColor: "#534082" }} />
                                                                            <span style={{ position: "absolute", top: "7px", fontSize: "13px", fontWeight: "bold", left: "2px" }}>%</span>
                                                                        </div>
                                                                        <NewNumberInput className="tableRowInput mt-0" minvalue={0} containerStyle={{ width: showSerial || showBarcode ? "60%" : "70%", display: "inline-block" }} style={{ borderRadius: "4px 0px 0px 4px" }}
                                                                            inputname="Discount" value={rowData.Discount ?? 0} onChange={onRowColChanged} step={0.01} /*readonly={invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale}*/ />

                                                                    </td>
                                                                    <td>
                                                                        <div style={{ position: "relative", display: "inline-block", width: showSerial || showBarcode ? "40%" : "30%" }}>
                                                                            <input type="number" className="tableRowInput" readOnly={invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale}
                                                                                max={100} min={0} name="TaxPercent" value={rowData.TaxPercent ?? taxPercent ?? 0} onChange={onRowColChanged} step={0.01} onFocus={selectText} style={{ borderRadius: "0px 4px 4px 0px", borderColor: "#534082" }} />
                                                                            <span style={{ position: "absolute", top: "7px", fontSize: "13px", fontWeight: "bold", left: "2px" }}>%</span>
                                                                        </div>
                                                                        <NewNumberInput className="tableRowInput mt-0" minvalue={0} containerStyle={{ width: showSerial || showBarcode ? "60%" : "70%", display: "inline-block" }} style={{ borderRadius: "4px 0px 0px 4px" }}
                                                                            inputname="Tax" value={rowData.Tax ?? 0} onChange={onRowColChanged} step={0.01} readonly={invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale} />
                                                                    </td>
                                                                </Fragment>
                                                            }
                                                            {invoiceType !== Resid && invoiceType !== Havaleh &&
                                                                <td>
                                                                    <NewNumberInput className="tableRowInput mt-0" readonly minvalue={0} defaultValue={0} inputname="PureTotalPrice"
                                                                        value={rowData.PureTotalPrice ?? 0} step={0.01} />
                                                                </td>}
                                                            {invoiceType === ServiceInvoice &&
                                                                <td style={{ width: "95px" }}>
                                                                    <select className="tableRowInput" name="IsGuarantee" ref={register({})} style={{ width: "92px", borderColor: "#534082", color: serviceIsGuarantee.toString() === "true" ? "green" : "red" }}
                                                                        defaultValue={currentServiceRow?.IsGuarantee ?? false} onChange={e => setServiceIsGuarantee(e.target.value)}>
                                                                        <option value={false} style={{ color: "red" }}>گارانتی نیست</option>
                                                                        <option value={true} style={{ color: "green" }}>گارانتی است</option>
                                                                    </select>
                                                                </td>
                                                            }
                                                            <td>
                                                                <select className="tableRowInput" name="CountingUnit" ref={register({})} defaultValue={currentRow?.CountingUnit ?? 1627}>
                                                                    {
                                                                        productCountingUnit.map((pc, i) => <option value={pc.UnitID}>{pc.UnitName}</option>)
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td><input type="text" className="tableRowInput" name="ItemDescription" ref={register({})} defaultValue={currentRow?.ItemDescription ?? ""} style={{ borderColor: "#534082" }} /></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            }
                                            {isMobile &&
                                                <Row>
                                                    {showBarcode &&
                                                        <FormGroup >
                                                            <label>بارکد کالا: </label>
                                                            <Form.Control />
                                                        </FormGroup>
                                                    }
                                                    <FormGroup>
                                                        <input type="hidden" value={currentRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                        <input type="hidden" value={currentRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                        <label>نام کالا: </label>
                                                        <Form.Control id="invoiceDetailProduct" ref={register({ required: true })} onKeyDown={showModalProduct} readOnly
                                                            value={selectedProduct?.ProductName ?? currentRow?.ProductName ?? ""} name="ProductName" />
                                                        <Button className="btn-input-tiny" onClick={showModalProduct}><List size={20} /></Button>
                                                        {errors && errors.ProductName && <small className="errors">انتخاب کالا الزامی است</small>}
                                                    </FormGroup>
                                                    {showSerial &&
                                                        <FormGroup>
                                                            <labe>سریال کالا: </labe>
                                                            <Form.Control id="invoiceDetailPSerial" name="ProductSerial" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}
                                                                value={selectedProduct?.ProductSerial ?? currentRow?.ProductSerial ?? ""} onChange={e => selectProduct({ ...selectedProduct, ProductSerial: e.target.value })} />
                                                            {(invoiceType === Sale || invoiceType === Havaleh ||
                                                                invoiceType === ReturnFromPurchase || invoiceType === Transfer ||
                                                                invoiceType === Borrow) && !(Number(currentRow?.ID) > 0) && <Button className="btn-input-tiny" onClick={showModalSerials}><List size={19} /></Button>}
                                                        </FormGroup>
                                                    }
                                                    <FormGroup>
                                                        <label>تعداد کالا: </label>
                                                        <Form.Control id="invoiceDetailPCount" type="number" name="ProductCount"
                                                            onChange={onRowColChanged}
                                                            value={selectedProduct?.SuggestedCount ?? currentRow?.ProductCount ?? 1} min={0} step={0.01} onFocus={selectText} />
                                                        {errors && errors.ProductCount && <small className="error">تعداد کالا الزامی است</small>}
                                                    </FormGroup>
                                                    {invoiceType !== Resid && invoiceType !== Havaleh &&
                                                        <FormGroup>
                                                            <label>قیمت واحد: </label>
                                                            <NewNumberInput className="tableRowInput" minvalue={0} inputname="UnitPrice" value={selectedProduct?.UnitPrice ?? rowData.UnitPrice ?? 0}
                                                                onChange={onRowColChanged} step={0.01} />
                                                        </FormGroup>
                                                    }
                                                    {isFormal === "true" &&
                                                        <Fragment>
                                                            <FormGroup>
                                                                <label style={{ width: "100%" }}> تخفیف: </label>
                                                                <div style={{ position: "relative", display: "inline-block", width: "27%", marginLeft: "3%" }}>
                                                                    <Form.Control type="number"
                                                                        max={100} min={0} name="DiscountPercent" value={rowData.DiscountPercent ?? 0} onChange={onRowColChanged} step={0.01} onFocus={selectText} />
                                                                    <span style={{ position: "absolute", top: "15px", fontSize: "13px", fontWeight: "bold", left: "4px" }}>%</span>
                                                                </div>
                                                                <NewNumberInput minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }}
                                                                    inputname="Discount" value={rowData.Discount ?? 0} onChange={onRowColChanged} step={0.01} />
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <label style={{ width: "100%" }}>مالیات: </label>
                                                                <div style={{ position: "relative", display: "inline-block", width: "27%", marginLeft: "3%" }}>
                                                                    <Form.Control type="number"
                                                                        max={100} min={0} name="TaxPercent" value={rowData.TaxPercent ?? 0} onChange={onRowColChanged} step={0.01} onFocus={selectText} />
                                                                    <span style={{ position: "absolute", top: "15px", fontSize: "13px", fontWeight: "bold", left: "4px" }}>%</span>
                                                                </div>
                                                                <NewNumberInput minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }}
                                                                    inputname="Tax" value={rowData.Tax ?? 0} onChange={onRowColChanged} step={0.01} />
                                                            </FormGroup>
                                                        </Fragment>
                                                    }
                                                    {invoiceType !== Resid && invoiceType !== Havaleh &&
                                                        <FormGroup>
                                                            <label>مبلغ قابل پرداخت: </label>
                                                            <NewNumberInput readonly minvalue={0} defaultValue={0} inputname="PureTotalPrice"
                                                                value={rowData.PureTotalPrice ?? 0} step={0.01} />
                                                        </FormGroup>}
                                                </Row>
                                            }
                                            {currentRow && <Button className="group-Btn mt-2" type="submit"><Pencil size={16} />&nbsp;ویرایش ردیف</Button>}
                                            {!currentRow && <Button className="group-Btn mt-2" type="submit"><Check2 size={18} />&nbsp;افزودن به جدول</Button>}
                                            <Button variant="danger" className="group-Btn mt-2" onClick={cancelRow}><DashCircle size={16} />&nbsp;انصراف</Button>
                                            {!isMobile &&
                                                <OverlayTrigger overlay={popInfo} trigger={["hover", "focus"]}>
                                                    <InfoSquareFill size={20} color="#ff6800" style={{ position: "absolute", left: "5px", bottom: "5px" }} />
                                                </OverlayTrigger>
                                            }
                                        </div>

                                    </div>
                                </form>
                            }
                            <BihamtaTable columns={groupDetails?.length > 0 ? groupTableCols : tableColes} rowButtons={groupDetails?.length > 0 ? null : tableRowButtons} maxHeight={317}
                                rowClick={setCurrentRowForEdit}
                                dataList={{ Data: groupDetails?.length > 0 ? groupDetails : invoiceDetails ? invoiceDetails.filter(d => !d.SignedForDelete).sort((c, d) => c.Index - d.Index) : [] }} />
                            {/** Service Invoice Details */}
                            {invoiceType === ServiceInvoice &&
                                <Row className="rowBorder mb-1 mt-3 p-1">
                                    <div className="rowTitle">فهرست خدمات</div>
                                    <div className="row mt-2">
                                        <div className="col-md-1" style={{ marginLeft: "auto" }}>
                                            {!showAddServiceRow && <Button className="group-Btn-smalll mt-1" title="ردیف جدید" onClick={showAddServiceDiv}><PlusSquare size={18} /></Button>}
                                        </div>
                                    </div>
                                    {(showAddServiceRow || currentServiceRow) &&
                                        <form onSubmit={handleSubmit(currentServiceRow ? editServiceRow : addNewServiceRow)} readOnly ref={frmNewServiceRow}>
                                            <div className="scThin" style={{ overflowX: "auto" }}>
                                                <div className="form-group" style={{ border: "1px solid gray", padding: "8px", borderRadius: "3px", backgroundColor: "#cdd7e273", minWidth: !isMobile ? "1190px" : 0, position: "relative" }} >
                                                    {!isMobile &&
                                                        <table className="flexTable">
                                                            <thead>
                                                                <tr>
                                                                    <th>تکنسین</th>
                                                                    <th>نوع خدمت</th>
                                                                    {Number(currentDetailType) === serviceInvoiceDetailTypes.DefinedService &&
                                                                        <th>تعرفه</th>
                                                                    }
                                                                    {Number(currentDetailType) !== serviceInvoiceDetailTypes.DefinedService &&
                                                                        <th>
                                                                            {currentDetailType === serviceInvoiceDetailTypes.OtherServices ? "شرح خدمت" :
                                                                                currentDetailType === serviceInvoiceDetailTypes.OtherParts ? "نام قطعه" :
                                                                                    currentDetailType === serviceInvoiceDetailTypes.DeadheadingPay ? "شرح مراجعه" :
                                                                                        "شرح دستی"
                                                                            }
                                                                        </th>
                                                                    }
                                                                    <th style={{ width: "50px" }}><label style={{ width: "50px" }}>تعداد</label></th>
                                                                    <th>قیمت واحد</th>
                                                                    {isFormal === "true" &&
                                                                        <Fragment>
                                                                            <th>تخفیف</th>
                                                                            <th>مالیات</th>
                                                                        </Fragment>
                                                                    }
                                                                    <th>قابل پرداخت</th>
                                                                    <th style={{ width: "95px" }} ><label style={{ width: "95px" }}>وضعیت گارانتی</label></th>
                                                                    <th>توضیحات</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div>
                                                                            <input type="hidden" name="StaffID" ref={register({})} readOnly value={selectedServiceStaff?.StaffID ?? currentServiceRow?.StaffID ?? ""} />
                                                                            <input className="tableRowInput" value={selectedServiceStaff?.StaffName ?? currentServiceRow?.StaffName ?? ""} readOnly name="StaffName" ref={register({})} style={{ borderColor: "#534082" }} />
                                                                            <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalStaffForService}><List size={16} /></Button>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input type="hidden" value={currentServiceRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                                        <input type="hidden" value={currentServiceRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                                        <select className="tableRowInput" name="DetailType" ref={register({ required: true })} onChange={onDetailTypeChanged} style={{ borderColor: "#534082" }} defaultValue={currentServiceRow?.DetailType ?? ""}>
                                                                            <option value="">انتخاب کنید</option>
                                                                            {Array.isArray(serviceDetailTypes?.Data) &&
                                                                                serviceDetailTypes.Data.map((sd, i) => <option value={sd.ID} key={i}>{sd.InfoName}</option>)
                                                                            }
                                                                        </select>
                                                                        {errors?.DetailType && <span className="errors">انتخاب نوع خدمت الزامی است</span>}
                                                                    </td>
                                                                    {Number(currentDetailType) === serviceInvoiceDetailTypes.DefinedService && <td>
                                                                        <select className="tableRowInput scThin" name="DefinedCostID" ref={register({})} style={{ borderColor: "#534082" }} onChange={onDefinedServiceChanged} defaultValue={currentServiceRow?.DefinedCostID ?? ""}>
                                                                            <option value="">انتخاب کنید</option>
                                                                            {Array.isArray(definedCosts.Data) &&
                                                                                definedCosts.Data.map((df, i) => <option value={df.ID} key={i}>{df.ItemDesc}</option>)
                                                                            }
                                                                        </select>

                                                                    </td>}
                                                                    {Number(currentDetailType) !== serviceInvoiceDetailTypes.DefinedService &&
                                                                        <td>
                                                                            <input className="tableRowInput" name="ManualDesc" ref={register({})} style={{ borderColor: "#534082" }} defaultValue={currentServiceRow?.ServiceDesc ?? ""} />
                                                                        </td>
                                                                    }
                                                                    <td style={{ width: "50px" }}>
                                                                        <input type="number" className="tableRowInput" name="ProductCount" style={{ borderColor: "#534082", width: "48px" }} onChange={onServiceRowColChanged} min={0} step={0.01}
                                                                            onFocus={selectText} ref={register({})} value={serviceRowData?.ProductCount ?? 1} />
                                                                        {errors?.ProductCount && <small className="error">تعداد الزامی است</small>}
                                                                    </td>
                                                                    <td>
                                                                        <NewNumberInput className="tableRowInput mt-0" minvalue={0} inputname="UnitPrice" value={serviceRowData.UnitPrice ?? 0} onChange={onServiceRowColChanged} step={0.01} reff={register({})} />
                                                                    </td>

                                                                    {isFormal === "true" &&
                                                                        <Fragment>
                                                                            <td>
                                                                                <div style={{ position: "relative", display: "inline-block", width: "30%" }}>
                                                                                    <input type="number" className="tableRowInput" max={100} min={0} name="DiscountPercent" style={{ borderColor: "#534082", borderRadius: "0px 4px 4px 0px" }}
                                                                                        value={serviceRowData.DiscountPercent ?? 0} onChange={onServiceRowColChanged} step={0.01} onFocus={selectText} ref={register({})} />
                                                                                    <span style={{ position: "absolute", top: "8px", fontSize: "13px", fontWeight: "bold", left: "2px" }}>%</span>
                                                                                </div>
                                                                                <NewNumberInput className="tableRowInput mt-0" minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }} style={{ borderRadius: "4px 0px 0px 4px" }}
                                                                                    inputname="Discount" value={serviceRowData.Discount ?? 0} onChange={onServiceRowColChanged} step={0.01} reff={register({})} />

                                                                            </td>
                                                                            <td>
                                                                                <div style={{ position: "relative", display: "inline-block", width: "30%" }}>
                                                                                    <input type="number" className="tableRowInput" ref={register({})} style={{ borderColor: "#534082", borderRadius: "0px 4px 4px 0px" }} max={100} min={0} name="TaxPercent"
                                                                                        value={serviceRowData.TaxPercent ?? taxPercent ?? 0} onChange={onServiceRowColChanged} step={0.01} onFocus={selectText} />
                                                                                    <span style={{ position: "absolute", top: "8px", fontSize: "13px", fontWeight: "bold", left: "2px" }}>%</span>
                                                                                </div>
                                                                                <NewNumberInput className="tableRowInput mt-0" minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }} style={{ borderRadius: "4px 0px 0px 4px" }}
                                                                                    inputname="Tax" value={serviceRowData.Tax ?? 0} onChange={onServiceRowColChanged} step={0.01} reff={register({})} />
                                                                            </td>
                                                                        </Fragment>
                                                                    }
                                                                    <td>
                                                                        <NewNumberInput className="tableRowInput mt-0" readonly minvalue={0} defaultValue={0} inputname="PureTotalPrice"
                                                                            value={serviceRowData.PureTotalPrice ?? 0} step={0.01} reff={register({})} />
                                                                    </td>
                                                                    <td style={{ width: "95px" }}>
                                                                        <select className="tableRowInput" name="IsGuarantee" ref={register({})} style={{ width: "92px", borderColor: "#534082", color: serviceIsGuarantee.toString() === "true" ? "green" : "red" }}
                                                                            defaultValue={currentServiceRow?.IsGuarantee ?? false} onChange={e => setServiceIsGuarantee(e.target.value)}>
                                                                            <option value={false} style={{ color: "red" }}>گارانتی نیست</option>
                                                                            <option value={true} style={{ color: "green" }}>گارانتی است</option>
                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="tableRowInput" name="ItemDescription" ref={register({})} style={{ borderColor: "#534082" }} defaultValue={currentServiceRow?.ItemDescription ?? ""} />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    }
                                                    {isMobile &&
                                                        <Row>
                                                            {showBarcode &&
                                                                <FormGroup >
                                                                    <label>بارکد کالا: </label>
                                                                    <Form.Control />
                                                                </FormGroup>
                                                            }
                                                            <FormGroup>
                                                                <input type="hidden" value={currentServiceRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                                <input type="hidden" value={currentServiceRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                                <label>نام کالا: </label>
                                                                <Form.Control id="serviceInvoiceDetailProduct" ref={register({ required: true })} onKeyDown={showModalProduct} readOnly
                                                                    value={currentServiceRow?.ProductName ?? ""} name="ProductName" />
                                                                <Button className="btn-input-tiny" onClick={showModalProduct}><List size={20} /></Button>
                                                                {errors && errors.ProductName && <small className="errors">انتخاب کالا الزامی است</small>}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <label>تعداد کالا: </label>
                                                                <Form.Control id="serviceInvoiceDetailPCount" type="number" name="ProductCount" onChange={onServiceRowColChanged} ref={register({})}
                                                                    value={currentServiceRow?.ProductCount ?? 1} min={0} step={0.01} onFocus={selectText} />
                                                                {errors && errors.ProductCount && <small className="error">تعداد کالا الزامی است</small>}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <label>قیمت واحد: </label>
                                                                <NewNumberInput className="tableRowInput" minvalue={0} inputname="UnitPrice" value={serviceRowData.UnitPrice ?? 0}
                                                                    onChange={onServiceRowColChanged} step={0.01} reff={register({})} />
                                                            </FormGroup>

                                                            {isFormal === "true" &&
                                                                <Fragment>
                                                                    <FormGroup>
                                                                        <label style={{ width: "100%" }}> تخفیف: </label>
                                                                        <div style={{ position: "relative", display: "inline-block", width: "27%", marginLeft: "3%" }}>
                                                                            <Form.Control type="number" ref={register({})}
                                                                                max={100} min={0} name="DiscountPercent" value={serviceRowData.DiscountPercent ?? 0} onChange={onServiceRowColChanged} step={0.01} onFocus={selectText} />
                                                                            <span style={{ position: "absolute", top: "15px", fontSize: "13px", fontWeight: "bold", left: "4px" }}>%</span>
                                                                        </div>
                                                                        <NewNumberInput minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }}
                                                                            inputname="Discount" value={serviceRowData.Discount ?? 0} onChange={onServiceRowColChanged} step={0.01} reff={register({})} />
                                                                    </FormGroup>
                                                                    <FormGroup>
                                                                        <label style={{ width: "100%" }}>مالیات: </label>
                                                                        <div style={{ position: "relative", display: "inline-block", width: "27%", marginLeft: "3%" }}>
                                                                            <Form.Control type="number" ref={register({})}
                                                                                max={100} min={0} name="TaxPercent" value={serviceRowData.TaxPercent ?? 0} onChange={onServiceRowColChanged} step={0.01} onFocus={selectText} />
                                                                            <span style={{ position: "absolute", top: "15px", fontSize: "13px", fontWeight: "bold", left: "4px" }}>%</span>
                                                                        </div>
                                                                        <NewNumberInput minvalue={0} containerStyle={{ width: "70%", display: "inline-block" }}
                                                                            inputname="Tax" value={serviceRowData.Tax ?? 0} onChange={onServiceRowColChanged} step={0.01} ref={register({})} />
                                                                    </FormGroup>
                                                                </Fragment>
                                                            }
                                                            <FormGroup>
                                                                <label>مبلغ قابل پرداخت: </label>
                                                                <NewNumberInput readonly minvalue={0} defaultValue={0} inputname="PureTotalPrice" reff={register({})}
                                                                    value={serviceRowData.PureTotalPrice ?? 0} step={0.01} />
                                                            </FormGroup>
                                                        </Row>
                                                    }
                                                    {currentRow && <Button className="group-Btn mt-2" type="submit"><Pencil size={16} />&nbsp;ویرایش ردیف</Button>}
                                                    {!currentRow && <Button className="group-Btn mt-2" type="submit"><Check2 size={18} />&nbsp;افزودن به جدول</Button>}
                                                    <Button variant="danger" className="group-Btn mt-2" onClick={cancelServiceRow}><DashCircle size={16} />&nbsp;انصراف</Button>
                                                    {!isMobile &&
                                                        <OverlayTrigger overlay={popInfo} trigger={["hover", "focus"]}>
                                                            <InfoSquareFill size={20} color="#ff6800" style={{ position: "absolute", left: "5px", bottom: "5px" }} />
                                                        </OverlayTrigger>
                                                    }
                                                </div>

                                            </div>
                                        </form>
                                    }
                                    <BihamtaTable columns={serviceTableCols} rowButtons={serviceTableRowButtons} maxHeight={317}
                                        rowClick={setCurrentServiceRowForEdit}
                                        dataList={{ Data: serviceInvoiceDetails ? serviceInvoiceDetails.filter(d => !d.SignedForDelete).sort((c, d) => c.Index - d.Index) : [] }} />
                                </Row>
                            }{/*ServiceInvoice */}

                            <Row style={{ border: "1px solid gray", borderRadius: "3px", margin: 0, paddingBottom: "12px" }}>
                                <Col className="form-group" style={{ marginLeft: "auto" }} md={invoice.PaymentMethod === 1 ? 5 : 2}>
                                    {(invoiceType === Resid || invoiceType === ReturnFromBorrow || invoiceType === Transfer || invoiceType === Purchase || invoiceType === PrePurchase || invoiceType === ReturnFromSale) &&
                                        <div className={invoice.PaymentMethod === 1 ? " col-md-5" : ""}>
                                            <label>انبار مقصد</label>
                                            <input type="text" className="form-control" onKeyDown={showModalStorage} value={invoice.StorageName?.length > 0 ? invoice.StorageName : defaultStorages.DestStorageName ?? ""} readOnly />
                                            <Button className="btn-input-tiny" style={{ left: "2px" }} onClick={showModalStorage}><List size={18} /></Button>
                                            {submitError && submitError.DestinationStorage && <small className="errors">{submitError.DestinationStorage}</small>}
                                        </div>
                                    }
                                    {(invoiceType === Sale || invoiceType === PreSale || invoiceType === Purchase || invoiceType === PrePurchase || invoiceType === Resid || invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale || invoiceType === ServiceInvoice) &&
                                        <div className={invoice.PaymentMethod === 1 ? " col-md-5" : ""}>
                                            <label>
                                                {(invoiceType === Sale || invoiceType === ReturnFromSale || invoiceType === PreSale) ? "فروشنده" :
                                                    (invoiceType === Purchase || invoiceType === PrePurchase || invoiceType === ReturnFromPurchase) ? "مسئول خرید" : "مسئول انبار"}
                                            </label>
                                            <input type="text" className="form-control" value={invoice.StaffName ?? ""} readOnly onKeyDown={showModalStaff} />
                                            <Button className="btn-input-tiny" style={{ left: "2px" }} onClick={showModalStaff}><List size={21} /></Button>
                                        </div>
                                    }
                                    {(invoiceType === Sale || invoiceType === Purchase || invoiceType === ReturnFromPurchase || invoiceType === ReturnFromSale || invoiceType === ServiceInvoice) && !isMobile &&
                                        <table className="flexTable mt-2" style={{ fontSize: "12px", fontWeight: "normal" }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ fontWeight: "normal", textAlign: "right" }}>نحوه تسویه فاکتور</th>
                                                    {invoice.PaymentMethod === 1 &&
                                                        <Fragment>
                                                            <th style={{ fontWeight: "normal", textAlign: "right" }}>مبلغ تسویه</th>
                                                            <th style={{ fontWeight: "normal", textAlign: "right" }}>{invoiceType === Purchase || invoiceType === ReturnFromSale ? "حساب مبدا" : "حساب مقصد"}</th>
                                                        </Fragment>}
                                                </tr>

                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: (invoice.PaymentMethod === 2 ? 50 : 100 / 3) + "%" }}>
                                                        <select className="form-control" style={{ height: "36.8px" }}
                                                            value={invoice.PaymentMethod ?? 0} disabled={(Number(invoice.PaymentMethod) === 2 && Number(invoice.PaymentChequeFunctionID) > 0) /*|| (Number(invoiceID) > 0 && Number(invoice.PaymentMethod) === 1 && Number(invoice.PaidAmount) > 0)*/}
                                                            onChange={onPaymentMethodChanged}>
                                                            <option value={0} style={{ width: "100%", display: "block" }}> تسویه نشده</option>
                                                            <option value={1} style={{ width: "100%", display: "block" }}>نقد</option>
                                                            <option value={2} style={{ width: "100%", display: "block" }}>چک و نقد</option>
                                                        </select>
                                                    </td>
                                                    {invoice.PaymentMethod === 1 &&
                                                        <Fragment>
                                                            <td style={{ width: 100 / 3 + "%" }}><NewNumberInput defaultValue={invoice.PaidAmount ?? 0} onChange={e => setInvoice({ ...invoice, PaidAmount: Number(e.target.value) })} /></td>
                                                            <td style={{ position: "relative", width: 100 / 3 + "%" }}>
                                                                <input type="text" className="form-control" value={invoice.TargetAccountName ?? ""} readOnly onKeyDown={showModalAccLevel3} />
                                                                <Button className="btn-input-tiny" style={{ top: "9px", left: "3px" }} onClick={showModalAccLevel3}><List size={21} /></Button>
                                                            </td>
                                                        </Fragment>
                                                    }
                                                    {
                                                        invoice.PaymentMethod === 2 && Number(invoiceID) > 0 &&
                                                        <td style={{ width: 100 / 4 + "%" }}>
                                                            <div style={{ display: "flex", alignItems: "center", height: "100%", paddingTop: "3px" }}>
                                                                <Button className="group-Btn-smalll" onClick={showModalChequeFunction}><List size={18} /></Button>
                                                            </div>
                                                        </td>
                                                    }
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                </Col>
                                {invoiceType !== Resid && invoiceType !== Havaleh &&
                                    <div className="form-group col-md-4">
                                        <table style={{ fontSize: "12px", float: "left" }}>
                                            <tbody>
                                                <tr >
                                                    <td>جمع کل: </td>
                                                    <td><input className="form-control tableRowInput" readOnly style={{ marginTop: 0 }} value={invoice.InvoiceTotalPrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} /></td>
                                                </tr>
                                                {invoiceType !== Borrow && invoiceType !== ReturnFromBorrow && invoiceType !== Resid && invoiceType !== Havaleh &&
                                                    invoiceType !== OldParts && invoiceType !== Transfer &&
                                                    <Fragment>
                                                        <tr>
                                                            <td>تخفیف: </td>
                                                            <td><NewNumberInput inputname="Discount_" className="tableRowInput" style={{ marginTop: 0 }} value={invoice.Discount ?? 0} readonly={isFormal === "true"}
                                                                onChange={e => otherCostChanged("Discount", e.target)} /></td>
                                                            {isFormal !== "true" &&
                                                                <Fragment>
                                                                    <td>
                                                                        <input type="number" className=" form-control tableRowInput" style={{ width: "72px", marginTop: 0 }} min={0} max={100} value={invoice.DiscountPercent ?? 0}
                                                                            onChange={e => otherCostChanged("DiscountPercent", e.target)} onFocus={selectText} />
                                                                    </td>
                                                                    <td style={{ fontSize: "13px", fontWeight: "bold" }}>%</td>
                                                                </Fragment>
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td>ارزش افزوده: </td>
                                                            <td><NewNumberInput className="tableRowInput" style={{ marginTop: 0 }} value={invoice.TaxFee ?? 0} onChange={e => otherCostChanged("TaxFee", e.target)} readonly={isFormal === "true"} /></td>
                                                            {isFormal !== "true" &&
                                                                <Fragment>
                                                                    <td>
                                                                        <input type="number" className=" form-control tableRowInput" style={{ width: "72px", marginTop: 0 }} min={0} max={100} value={invoice.TaxPercent ?? 0}
                                                                            onChange={e => otherCostChanged("TaxPercent", e.target)} readOnly={isFormal === "true"} onFocus={selectText} />
                                                                    </td>
                                                                    <td style={{ fontSize: "13px", fontWeight: "bold" }}>%</td>
                                                                </Fragment>
                                                            }
                                                        </tr>
                                                        <tr>
                                                            <td>سایر هزینه ها: </td>
                                                            <td><NewNumberInput className="tableRowInput" style={{ marginTop: 0 }} value={invoice.FreightCharge ?? 0} onChange={e => otherCostChanged("FreightCharge", e.target)} /></td>
                                                        </tr>
                                                        <tr>
                                                            <td>قابل پرداخت: </td>
                                                            <td><input className="tableRowInput form-control" style={{ marginTop: 0 }} readOnly value={invoice.InvoicePureTotalPrice ? invoice.InvoicePureTotalPrice.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0} /></td>
                                                        </tr>
                                                        {(invoiceType === Sale || invoiceType === ServiceInvoice) && Number(invoice.InvoiceID) > 0 &&
                                                            <tr>
                                                                <td>سود فروش:</td>
                                                                <td><NewNumberInput className="tableRowInput" style={{ marginTop: 0 }} value={invoice.SaleProfit ?? 0} readonly /></td>
                                                            </tr>}
                                                    </Fragment>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </Row>
                            <div className="row mt-1" style={{ border: "1px solid gray", borderRadius: "3px", margin: 0, paddingBottom: "12px", position: "relative" }}>
                                <div className="col-md-5 form-group">
                                    <label>توضیحات</label>
                                    <textarea className="form-control" rows={2} onChange={e => setInvoice({ ...invoice, Description: e.target.value })} value={invoice.Description ?? ""} maxLength={2000} />
                                </div>
                                {(invoiceType === Purchase || invoiceType === PrePurchase || invoiceType === Sale || invoiceType === PreSale) && !isMobile &&
                                    <div className="col-md-4 form-group">
                                        <label>شرح دستی سند</label>
                                        <textarea className="form-control" rows={2} onChange={e => setInvoice({ ...invoice, ManualDocDesc: e.target.value })} value={invoice.ManualDocDesc ?? ""} maxLength={1000} />
                                    </div>
                                }
                                {(invoiceType === Sale || invoiceType === PreSale) && !isMobile &&
                                    <div className="col-md-12 form-group">
                                        <label>نشانی تحویل</label>
                                        <textarea className="form-control" rows={1} onChange={e => setInvoice({ ...invoice, DeliverAddress: e.target.value })} value={invoice.DeliverAddress ?? ""} maxLength={1000} />
                                    </div>
                                }
                                {!isMobile && (Number(invoiceID) > 0) &&
                                    <div style={{ position: "absolute", left: 0, maxWidth: "200px", width: "fit-content", top: "5px", color: "blue", fontSize: "9px", textAlign: "right" }}>
                                        {
                                            invoice.PCreationDate !== undefined && invoice.PCreationDate.length > 0 &&
                                            <div>
                                                &nbsp;<Calendar2DateFill size={12} color="#2894b1" /><label>&nbsp;تاریخ ثبت: <label style={{ direction: "ltr" }}>{invoice.PCreationDate}</label></label>
                                            </div>
                                        }
                                        {invoice.CreateByName?.length > 0 &&
                                            <div >
                                                <PersonPlusFill size={15} color="#ff5e00" /><label>&nbsp;ثبت کننده: {invoice.CreateByName}</label>
                                            </div>
                                        }
                                        {
                                            invoice.PUpdateDate?.length > 0 &&
                                            <div>
                                                &nbsp;<Calendar2CheckFill size={12} color="#bc1d72" /><label>&nbsp;تاریخ ویرایش: <label style={{ direction: "ltr" }}>{invoice.PUpdateDate}</label></label>
                                            </div>
                                        }
                                        {invoice.UpdateByName?.length > 0 &&
                                            <div >
                                                <PersonCheckFill size={15} color="#6e0bd0" /><label>&nbsp;ویرایش کننده: {invoice.UpdateByName}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            {submitError?.Details &&
                                <Alert className="mt-1" variant="danger"><ExclamationTriangle size={18} />&nbsp; {submitError.Details}</Alert>
                            }
                            <div className="row mt-2" style={{ position: "sticky", bottom: "10px" }}>
                                <div className="col-md-10" style={{ marginLeft: "auto" }} ref={divButtons}>
                                    <Button variant="success" className="group-Btn" disabled={invoice.ConvertedToInvoice || !checkedIn} onClick={submitInvoice}>
                                        <CheckLg size={14} />&nbsp;{(Number(invoiceID) > 0 ? "ویرایش " : "ثبت ") + pInvoiceType(invoiceType)}</Button>
                                    {Number(invoiceID) > 0 &&
                                        <Fragment>
                                            <OverlayTrigger trigger="click" overlay={popPrintMenu} rootClose>
                                                <Button variant="secondary" className="group-Btn" keyname="print"><Printer size={16} />&nbsp;چاپ {pInvoiceType(invoiceType)}</Button>
                                            </OverlayTrigger>
                                            <Button variant="danger" className="group-Btn" keyname="delete" disabled={invoice.ConvertedToInvoice || !checkedIn} onClick={deleteInvc}><Trash size={16} />&nbsp;حذف {pInvoiceType(invoiceType)}</Button>
                                            {(invoiceType === PreSale || invoiceType === PrePurchase) && Number(invoice?.InvoiceStateCode) === invoiceStates.Approved && !invoice.ConvertedToInvoice &&
                                                <Button className="group-Btn" keyname="convert" disabled={!checkedIn} onClick={convertToInvoice}><Toggles2 />&nbsp;تبدیل به فاکتور</Button>}
                                            {(invoiceType === PreSale || invoiceType === PrePurchase) && isFormal !== 'true' && Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                                                !invoice.ConvertedToInvoice &&
                                                <Button className="group-Btn btn-violet" keyname="convertF" disabled={!checkedIn} onClick={showModalConvert}><Toggles2 />&nbsp;تبدیل به فاکتور رسمی</Button>}

                                            {invoice.ConvertedToInvoice && invoice.RelatedInvoiceID && (invoiceType === PreSale || invoiceType === PrePurchase) &&
                                                <Button className="group-Btn" keyname="related" onClick={goToConverted}><FileEarmarkPost size={16} /> &nbsp; فاکتور مرتبط</Button>
                                            }
                                            {invoiceType === Sale && Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                                                <Button className="group-Btn" keyname="link" onClick={sendSMS}><Envelope size={16} />&nbsp;پیامک لینک فاکتور</Button>}
                                            {(invoiceType === Sale ||
                                                invoiceType === ServiceInvoice ||
                                                invoiceType === Purchase ||
                                                invoiceType === ReturnFromPurchase ||
                                                invoiceType === ReturnFromSale ||
                                                invoiceType === Borrow ||
                                                invoiceType === ReturnFromBorrow || invoiceType === OldParts) &&
                                                Number(invoice?.InvoiceStateCode) === invoiceStates.Approved &&
                                                <Button className="group-Btn" keyname="document" variant="info" onClick={gotoDocument}><FileEarmarkPost size={16} />&nbsp;مشاهده سند فاکتور</Button>
                                            }
                                            <OverlayTrigger trigger="click" placement="top" overlay={popAttachments} rootClose>
                                                <Button variant="light" keyname="attachs" className="group-Btn btn-violet" onClick={loadAttachList}><Link45deg size={19} />&nbsp;پیوست ها</Button>
                                            </OverlayTrigger>
                                            {(Number(invoice?.InvoiceStateCode) === invoiceStates.Draft || Number(invoice?.InvoiceStateCode) === invoiceStates.WatingForApprove) &&
                                                <Button variant="info" className="group-Btn" keyname="approve" onClick={approve}><Check2Square size={19} />&nbsp;تایید فاکتور</Button>
                                            }
                                            <Button className="group-Btn" keyname="new" onClick={gotoNewInvoice}><FileEarmarkPlus size={17} />&nbsp; فاکتور جدید</Button>
                                            <Button className="group-Btn" keyname="copy" variant="success" onClick={copyInvoice}><Files size={16} />&nbsp; تکرار فاکتور</Button>
                                            <Button className="group-Btn" keyname="command" variant="info" onClick={showCommand}><Command size={16} />&nbsp; دستور کار</Button>
                                            <Button className="group-Btn" keyname="referDoc" onClick={showDocRefer}><ReplyFill size={17} /><Person className='defaultIcon' />&nbsp;ارجاع به کاربر</Button>
                                            <Button className="group-Btn" keyname="reminder" variant="secondary" onClick={showModalReminder}><CalendarDate size={15} />&nbsp; یادآوری</Button>
                                            <Button className="group-Btn" keyname="customerSig" onClick={showSignatureForCustomer} ><VectorPen size={15} />&nbsp;امضای تحویل گیرنده</Button>
                                            <Button className="group-Btn" keyname="salesmanSig" onClick={showSignatureForSalesman}><VectorPen size={15} />&nbsp;امضای تحویل دهنده</Button>
                                            <Button className="group-Btn" keyname="task" onClick={showModalWorkItemData}><Check2Square />&nbsp;ثبت وظیفه</Button>
                                            {showMenuButton && <OverlayTrigger overlay={popMenu} trigger="click" rootClose><Button className="btn-violet group-Btn"><List size={17} /></Button></OverlayTrigger>}
                                        </Fragment>}
                                </div>
                            </div>
                            {!isMobile &&
                                <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={popShortKeys}>
                                    <div className="col-md-2" style={{ textAlign: "left", color: "blue", fontSize: "11px", position: "absolute", left: "10px", bottom: "35px" }}>
                                        <FontAwesomeIcon icon={faInfoCircle} size="sm" />&nbsp;<label style={{ cursor: "pointer" }}>کلیدهای میانبر</label>
                                    </div>
                                </OverlayTrigger>
                            }
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div >
    )
}
export default Invoice;